import React from 'react';
import axios from "../../../containers/api";
import DatePicker, { utils } from 'react-modern-calendar-datepicker';
import { Link } from "react-router-dom";
import { Table } from "../../../components/table/Table";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { convertDate, convertDateToDatepicker, getkalas, getLoaderTypes, getBastebandys, showCatchError, toEnglishNumbers, toCurrency, getDurationHour, getDayBefore, GetDistinctLoaderTypes } from "../../../helpers/Utils";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import { Button, Card, CardTitle, CardBody, Collapse, Input, ModalBody, Modal, ModalHeader, Row, Alert, InputGroupAddon, InputGroup, FormGroup, Label, CustomInput, ModalFooter } from "reactstrap";
import Config from "../../../constants/config";
import "../../../assets/css/sass/maps.css";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import AddCustomerModal from "../../info-base/customer/components/AddCustomerModal";
import EditCustomer from "../../info-base/customer/components/EditCustomer";
import Customer from "../../info-base/customer/Customer";
import ManageCustomerAddress from "../../info-base/customer/components/ManageCustomerAddress";

const isEmpty = (v) => v === null || v === "" || v === undefined;
const isSelectEmpty = (v) => !v || v.value === undefined || v.value === null;
const isAutocompleteEmpty = (v) => v === null || v === undefined;
const isInvalidNumber = (v) => {
    const n = Number(toEnglishNumbers(v));
    return isNaN(n) || n <= 0;
};

const validateTime = (hour, minute, label, error, errorInputs, prefix) => {

    // ⛔ خالی
    if (!hour || !minute) {
        error.push(`وارد کردن ساعت ${label} الزامی میباشد`);
        errorInputs.push(`${prefix}Hour`, `${prefix}Minute`);
        return;
    }

    // ⛔ فرمت دو رقمی
    if (!/^\d{2}$/.test(hour)) {
        error.push(`ساعت ${label} باید دو رقمی باشد`);
        errorInputs.push(`${prefix}Hour`);
    }

    if (!/^\d{2}$/.test(minute)) {
        error.push(`دقیقه ${label} باید دو رقمی باشد`);
        errorInputs.push(`${prefix}Minute`);
    }

    const h = parseInt(hour);
    const m = parseInt(minute);

    // ⛔ بازه
    if (h < 0 || h > 23) {
        error.push(`ساعت ${label} نامعتبر است`);
        errorInputs.push(`${prefix}Hour`);
    }

    if (m < 0 || m > 59) {
        error.push(`دقیقه ${label} نامعتبر است`);
        errorInputs.push(`${prefix}Minute`);
    }

    // ⛔ 00:00 مجاز نیست
    if (h === 0 && m === 0) {
        error.push(`ساعت ${label} نمی‌تواند 00:00 باشد`);
        errorInputs.push(`${prefix}Hour`, `${prefix}Minute`);
    }
};
const now = new Date();
//const financialInput = {
//    baseFare: 0,
//    preFare: 0,
//    items: {
//        sleep: 0,
//        baskol: 0,
//        bargiri: 0,
//        bime: 0,
//        payane: 0,
//        commission: 0
//    },
//    settings: [
//        {
//            key: 'sleep',
//            isPercent: true,
//            percent: 5,
//            receivDriver: true,
//            addFare: false
//        }
//    ],
//    insuranceType: 'BillFinancialSetting', // GoodValue | Formula
//    goodValue: 0
//};

class AddBill extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            draftId: this.props.match.params.draftId,
            BillId: 0,
            BillHour: String(now.getHours()).padStart(2, "0"),
            BillMinute: String(now.getMinutes()).padStart(2, "0"),
            customer: [],
            sender: null,
            senderAddresses: [],
            senderAddress: null,
            receiver: null,
            receiverAddresses: [],
            receiverAddress: null,
            FreighterInsuranceExpireDate: utils('fa').getToday(),
            kalaValue: null,
            kala: null,
            Bastebandy: null,
            FreighterCardNumber: "",
            KalaQuantity: "",

            BaseFreightAmount: 0,
            PayanehCost: 0,
            Commission: 0,
            InsuranceAmount: 0,
            PreFreight: 0,
            RightPasokool: 0,
            SleepRight: 0,
            OtherExpenses: 0,
            ReceivedFromDriver: 0,
            RemainingFreight: 0,

            DriverTotal: 0,
            TotalFare: 0,

            // اینجا مقدار اولیه settings رو بذار
            FinancialSettings: [
                { key: 'sleep', isPercent: true, percent: 5, receivDriver: true, addFare: false },
                { key: 'baskol', isPercent: false, receivDriver: true, addFare: false },
                { key: 'bargiri', isPercent: false, receivDriver: true, addFare: false },
                { key: 'bime', isPercent: false, receivDriver: true, addFare: false },
                { key: 'payane', isPercent: false, receivDriver: true, addFare: false },
                { key: 'commission', isPercent: false, receivDriver: true, addFare: false }
            ],

            InsuranceType: 'BillFinancialSetting',
            GoodValue: 0,

            Desc: "",
            selectedLoaderTypes: null,
            selectedLoaderTypeCode: null,
            SenderSourceCity: "",
            ReceiverDestinationCity: "",
            Rubari: false,
            IsReturned: false,
            errors: [],
            errorInputs: [],
            senders: [],
            receivers: [],

            addCustomerModal: false,
            editCustomerModal: false,
            manageCustomerModal: false,
            manageCustomersModal: false,
            senderOptionsMenu: null,
            receiverOptionsMenu: null,
            currentCustomer: [],
            Bastebandys: [],
            kalas: [],
            loaderTypes: [],
            loaderTypeCodes: [],
            provinces: [],
            //////////////
            Billdate: utils('fa').getToday(),

            EstimatedArrivalDate: null,
            //BillMinute: "",
            //BillHour: "",

            BillOfLadingNumber: "",
            BillOfLadingSeries: "",

            selectedRentalType: { value: 1, text: 'کرایه در مقصد' },
            RentalType: [
                { value: 1, text: 'کرایه در مقصد' },
                { value: 2, text: 'پس از رسید' },
                { value: 3, text: 'صافی کرایه' }
            ],

            selectedShippingStatus: { value: 0, text: '' },
            ShippingStatus: [
                { value: 1, text: 'معمولی' },
                { value: 2, text: 'ترافیکی' },
                { value: 3, text: 'آتشزا' },
                { value: 4, text: 'ST' },

            ],
            ShippingContractList: [],
            ShippingContract: null,
            KalaGroupList: [],
            KalaGroup: null,

            TransportationCompanyProductOwnerList: [],
            TransportationCompanyProductOwner: null,
            InsuranceContractList: [],
            InsuranceContract: null,
            OrderNumber: "",
            DriverNationalId: "",
            DriverPassword: "",
            FreighterPassword: "",
            DriverFullName: "",
            DriverMobile: "",
            DriverNationalId2: "",
            DriverMobile2: "",
            DriverFullName2: "",
            DriverCardNumber: "",
            DriverCardNumber2: "",
            PlaqueNumber: "",
            PlaqueNumber1: "",
            PlaqueSerialNumber: "",
            FreighterInsuranceNumber: "",
            IsActiveCard: false,
            IsActiveCard2: false,
            HealthCardValidationDate: "",
            CardValidationDate: "",
            HealthCardValidationDate2: "",
            CardValidationDate2: "",
            ExaminationValidDate: "",
            KalaNote: "",
            kalaWeight: "",
            KalaDesc: "",
            ProductOwnerId: null,

            SteelInformationModal: false,
            CustomsInformationModal: false,
            BillPaymentModal: false,
            OilModal: false,
            IsCustomsInformation: false,
            IsSteelInformation: false,
            IsBillPayment: false,
            IsOil: false,

            ContainerNumber1: "",
            ContainerNumber2: "",
            CotageNumber: "",
            CotageDate: null,
            ProductBarcode: "",
            CustomsSealNumber: "",
            CustomsPermitNumber: "",

            SteelOrderNumber: "",
            SteelDraftPosition: "",
            SteelPlannedWeight: "",
            SteelQuantity: "",
            SteelCustomerName: "",
            SteelCustomerCode: "",
            SteelProductType: "",
            SteelThickness: "",
            SteelWidth: "",
            SteelLength: "",
            SteelUsefulLength: "",
            SteelISG: "",
            SteelItem: "",
            SteelWarehouse: "",
            SteelLoadingPoint: "",
            SteelProgram: "",
            SteelDescription: "",
            Mechanism: "",
            steelErrors: [],
            steelErrorInputs: [],
            oilErrors: [],
            oilErrorInputs: [],
            loading: false,
            HavalehTraceCode: "",

            PayerPhone: "",
            PayerBirthDate: null,
            PayerNationalId: "",
            PayerCompanyNationalId: "",
            PayerManagerNationalId: "",
            PayerManagerPhone: "",
            PayerManagerBirthDate: null,
            ReceiverNationalId: "",
            ReceiverPhone: "",
            ReceiverBirthDate: "",

            DraftOrBillNumber: "",
            IssueDate: null,
            Temperature: "",
            SpecificGravity: "",
            NaturalQuantity: "",
            Quantityat60Degrees: "",
            KalaWeight: "",
            RahdardiNumber: "",
            OilInsuranceContract: null,
            coefficients: [], 

        };

    }
  
    //componentDidUpdate(prevProps, prevState) {
    //    if (
    //        prevState.BaseFreightAmount !== this.state.BaseFreightAmount ||
    //        prevState.PreFreight !== this.state.PreFreight ||
    //        prevState.PayanehCost !== this.state.PayanehCost ||
    //        prevState.Commission !== this.state.Commission ||
    //        prevState.InsuranceAmount !== this.state.InsuranceAmount ||
    //        prevState.RightPasokool !== this.state.RightPasokool ||
    //        prevState.SleepRight !== this.state.SleepRight
    //    ) {
    //        this.calculate();
    //    }
    //}

    //calculate = () => {
    //    const result = calculateFinancial({
    //        baseFare: Number(this.state.BaseFreightAmount || 0),
    //        preFare: Number(this.state.PreFreight || 0),
    //        items: {
    //            sleep: Number(this.state.SleepRight || 0),
    //            baskol: Number(this.state.RightPasokool || 0),
    //            bargiri: 0, // اضافه کن اگر لازم داری
    //            bime: Number(this.state.InsuranceAmount || 0),
    //            payane: Number(this.state.PayanehCost || 0),
    //            commission: Number(this.state.Commission || 0)
    //        },
    //        settings: this.state.FinancialSettings || [],
    //        insuranceType: this.state.InsuranceType,
    //        goodValue: this.state.GoodValue || 0
    //    });

    //    this.setState({
    //        DriverTotal: result.driverTotal,
    //        TotalFare: result.finalTotal
    //    });
    //};

    handleChange = (field) => (e) => {
        const value = e.target.value.replace(/[^0-9]/g, "");
        this.setState({ [field]: value });
    };

    reset = () => {
        this.props.closeSweetAlert();

        this.setState({
            draftId: 0,
            BillId: 0,
            BillHour: String(now.getHours()).padStart(2, "0"),
            BillMinute: String(now.getMinutes()).padStart(2, "0"),
            sender: null,
            senderAddresses: [],
            senderAddress: null,
            receiver: null,
            receiverAddresses: [],
            receiverAddress: null,
            FreighterInsuranceExpireDate: utils('fa').getToday(),
            kalaValue: null,
            kala: null,
            Bastebandy: null,
            FreighterCardNumber: "",
            KalaQuantity: "",

            BaseFreightAmount: null,
            PayanehCost: null,
            Commission: null,
            InsuranceAmount: null,
            PreFreight: null,
            RightPasokool: null,
            SleepRight: null,
            OtherExpenses: null,
            ReceivedFromDriver: null,
            RemainingFreight: null,

            Desc: "",
            selectedLoaderTypes: null,
            selectedLoaderTypeCode: null,
            SenderSourceCity: "",
            ReceiverDestinationCity: "",
            Rubari: false,
            IsReturned: false,
            errors: [],
            errorInputs: [],

            //////////////
            Billdate: utils('fa').getToday(),


            EstimatedArrivalDate: null,



            selectedRentalType: { value: 1, text: 'کرایه در مقصد' },



            selectedShippingStatus: { value: 0, text: '' },


            ShippingContract: null,
            KalaGroup: null,



            TransportationCompanyProductOwner: null,

            InsuranceContract: null,
            OrderNumber: "",
            DriverNationalId: "",
            DriverPassword: "",
            FreighterPassword: "",
            DriverFullName: "",
            DriverMobile: "",
            DriverNationalId2: "",
            DriverMobile2: "",
            DriverFullName2: "",
            DriverCardNumber: "",
            DriverCardNumber2: "",
            PlaqueNumber: "",
            PlaqueNumber1: "",
            PlaqueSerialNumber: "",
            FreighterInsuranceNumber: "",
            IsActiveCard: false,
            IsActiveCard2: false,
            HealthCardValidationDate: "",
            CardValidationDate: "",
            HealthCardValidationDate2: "",
            CardValidationDate2: "",
            ExaminationValidDate: "",
            KalaNote: "",
            kalaWeight: "",
            KalaDesc: "",
            ProductOwnerId: null,

            HavalehTraceCode: "",




        });
    }
    restSteelInformation = () => {
        this.setState({
            SteelOrderNumber: "",
            SteelDraftPosition: "",
            SteelPlannedWeight: "",
            SteelQuantity: "",
            SteelCustomerName: "",
            SteelCustomerCode: "",
            SteelProductType: "",
            SteelThickness: "",
            SteelWidth: "",
            SteelLength: "",
            SteelUsefulLength: "",
            SteelISG: "",
            SteelItem: "",
            SteelWarehouse: "",
            SteelLoadingPoint: "",
            SteelProgram: "",
            SteelDescription: "",
            Mechanism: "",
            IsSteelInformation: false,
            SteelInformationModal: true,
        });
    }
    restCustomsInformation = () => {
        this.setState({
            ContainerNumber1: "",
            ContainerNumber2: "",
            CotageNumber: "",
            CotageDate: null,
            ProductBarcode: "",
            CustomsSealNumber: "",
            CustomsPermitNumber: "",
            IsCustomsInformation: false,
            CustomsInformationModal: true,
        });
    }
    resetBillPayment = () => {
        this.setState({

            PayerPhone: "", PayerBirthDate: null, PayerNationalId: "", PayerCompanyNationalId: "", PayerManagerNationalId: ""
            , PayerManagerPhone: "", PayerManagerBirthDate: null, ReceiverNationalId: "", ReceiverPhone: "", ReceiverBirthDate: "",
            IsBillPayment: false,
            BillPaymentModal: true,
        });
    }
    resetOil = () => {
        this.setState({

            DraftOrBillNumber: "",
            IssueDate: null,
            Temperature: "",
            SpecificGravity: "",
            NaturalQuantity: "",
            Quantityat60Degrees: "",
            KalaWeight: "",
            RahdardiNumber: "",
            OilInsuranceContract: null,
            IsOil: false,
            OilModal: true,
        });
    }
    checkAndLoad = () => {
        const { Bastebandys, loaderTypes, kalas, loading } = this.state;
        if (Bastebandys.length && loaderTypes.length && kalas.length && !loading) {
            this.setState({ loading: true }, () => this.GetDraftById());
        }
    };
    GetDraftById = () => {

        this.props.showSpinner();
        axios.get('/api/v1/drafts/GetDraftById/' + toEnglishNumbers(this.state.draftId))
            .then((res) => {
                this.props.hideSpinner();
                this.setState({

                    HavalehTraceCode: res.data.data.draftCode,
                    kalaValue: res.data.data.kalaValue,
                    kalaWeight: res.data.data.kalaWeight,
                    Desc: res.data.data.desc,


                    SenderSourceCity: res.data.data.senderSourceCityName,
                    ReceiverDestinationCity: res.data.data.receiverDestinationCityName,
                    IsReturned: res.data.data.isReturned,
                    Rubari: res.data.data.rubari,
                    //DraftTime: res.data.data.DraftTime,
                    /* Billdate: convertDateToDatepicker(res.data.data.billdate),*/
                    OrderNumber: res.data.data.orderNumber,

                    DriverNationalId: res.data.data.driverNationalId,
                    DriverFullName: res.data.data.driverFullName
                    , DriverMobile: res.data.data.driverMobile
                    //// , DriverId: res.data.data.id
                    , IsActiveCard: res.data.data.isActiveCard
                    , DriverCardNumber: res.data.data.driverCardNumber
                    , DriverCardNumber2: res.data.data.driverCardNumber2
                    , HealthCardValidationDate: res.data.data.healthCardValidationDate
                    , CardValidationDate: res.data.data.cardValidationDate
                    , DriverFullName2: res.data.data.driverFullName2
                    , DriverMobile2: res.data.data.driverMobile2
                    //// , DriverId2: res.data.data.id
                    , IsActiveCard2: res.data.data.isActiveCard2
                    , DriverNationalId2: res.data.data.driverNationalId2
                    , HealthCardValidationDate2: res.data.data.healthCardValidationDate2
                    , CardValidationDate2: res.data.data.cardValidationDate2
                    , FreighterCardNumber: res.data.data.freighterCardNumber
                    , PlaqueSerialNumber: res.data.data.plaqueSerialNumber
                    , PlaqueNumber1: res.data.data.plaqueNumber.length >= 2 ? res.data.data.plaqueNumber.substring(0, 2) : ""
                    , PlaqueNumber: res.data.data.plaqueNumber.length >= 4 ? res.data.data.plaqueNumber.substring(res.data.data.plaqueNumber.length - 3) : ""
                    , ExaminationValidDate: res.data.data.examinationValidDate
                    , FreighterInsuranceExpireDate: convertDateToDatepicker(res.data.data.freighterInsuranceExpireDate)
                    , FreighterInsuranceNumber: res.data.data.freighterInsuranceNumber
                    , LoaderTypeId: res.data.data.loaderTypeId
                    , LoadingTypeCode: res.data.data.loaderTypeCode
                    , LoadingTypeTitle: res.data.data.loadingTypeTitle

                    , KalaQuantity: res.data.data.kalaQuantity
                    , KalaNote: res.data.data.kalaNote


                    , selectedShippingStatus: this.state.ShippingStatus.find(x => x.value === res.data.data.shippingStatus) || { value: 0, text: '' }
                    , selectedRentalType: this.state.RentalType.find(x => x.value === res.data.data.rentalType) || { value: 0, text: '' }
                    , EstimatedArrivalDate: convertDateToDatepicker(res.data.data.estimatedArrivalDate)

                });

                this.state.loaderTypes && this.state.loaderTypes.map((v) => {
                    if (v.id === res.data.data.loaderTypeId) {
                        this.setState({ selectedLoaderTypes: v });
                    }
                });
                this.state.loaderTypeCodes && this.state.loaderTypeCodes.map((v) => {
                    if (v.typeCode === res.data.data.loaderTypeCode) {
                        this.setState({ selectedLoaderTypeCode: v });
                    }
                });
                this.state.ShippingContractList && this.state.ShippingContractList.map((v) => {
                    if (v.id === res.data.data.shippingContractId) {
                        this.setState({ ShippingContract: v });
                    }
                });

                this.state.InsuranceContractList && this.state.InsuranceContractList.map((v) => {
                    if (v.id === res.data.data.insuranceContractId) {
                        this.setState({ InsuranceContract: v });
                    }
                });


                this.state.loaderTypeCodes && this.state.loaderTypeCodes.map((v) => {
                    if (v.typeCode === res.data.data.typeCode) {
                        this.setState({ selectedLoaderTypeCode: v });
                    }
                });

                this.state.kalas && this.state.kalas.map((v) => {
                    if (v.id === res.data.data.kalaId) {
                        this.setState({ kala: v });
                    }
                });
                this.state.Bastebandys && this.state.Bastebandys.map((v) => {
                    if (v.id === res.data.data.bastebandyId) {
                        this.setState({ Bastebandy: v });
                    }
                });
                this.state.TransportationCompanyProductOwnerList && this.state.TransportationCompanyProductOwnerList.map((v) => {
                    if (v.id === res.data.data.transportationCompanyProductOwnerId) {
                        this.setState({ TransportationCompanyProductOwner: v });
                    }
                });


                //this.state.loaderTypes && this.state.loaderTypes.map((v) => {
                //    if (v.value === res.data.data.loadType) {
                //        this.setState({LoadType: v});
                //    }
                //});





                //if (res.data.data.customerAddress === null) {
                //    this.setState({AddLoadType: 1},
                //        () => {
                //            this.setState({
                //                mapSourceInput: res.data.data.cargoSource,
                //                mapDestinationInput: res.data.data.cargoDestination
                //            })
                //        });
                //} else
                if (res.data.data.senderCustomerId && res.data.data.receiverCustomerId) {

                    if (this.state.customer != null) {

                        this.state.customer.map((Customer) => {
                            if (Customer.id === res.data.data.senderCustomerId) {
                                this.setState({ sender: Customer },
                                    () => this.loadSenderAddresses(res.data.data.senderCustomerId, res.data.data.senderCustomerAddressId));
                            }
                            if (Customer.id === res.data.data.receiverCustomerId) {
                                this.setState({ receiver: Customer },
                                    () => this.loadReceiverAddresses(res.data.data.receiverCustomerId, res.data.data.receiverCustomerAddressId));
                            }
                        });
                    }

                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    async componentDidMount() {

        //console.log('adddaraflog');
        //try {
        //    this.getBastebandysApi().then(r => console.log(r));
        //} catch (err) {
        //    console.log(err);
        //}
        //try {
        //    this.getkalasApi().then(r => console.log(r));
        //} catch (err) {
        //    console.log(err);
        //}
        //try {
        //    this.GetDistinctLoaderTypes().then(r => console.log(r));
        //} catch (err) {
        //    console.log(err);
        //}
        try {
            await Promise.all([

                this.getBastebandysApi(),
                this.GetDistinctLoaderTypes(),
                this.getLoaderTypesApi(),
                this.getkalasApi(),
                this.TransportationCompanyShippingContract(),
                this.TransportationCompanyKalaGroup(),

                this.TransportationCompanyProductOwner(),
                this.TransportationCompanyInsuranceContract(),
                this.GetCustomerByTransportationCompanyId(),
                this.GetFinancialBill(),
            ]);

            this.checkAndLoad();
        } catch (err) {
            console.error("خطا در گرفتن اطلاعات اولیه:", err);
        }


    }
    searchDriverBy = () => {
        this.props.showSpinner();
        let url = 'api/v1/drivers/GetDriverInfoByNationalIdandInquiry/'
        axios.get(url + toEnglishNumbers(this.state.DriverNationalId))
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data === null || res.data.data.length === 0) {
                    this.props.showAlert("راننده‌ای با مشخصات مورد نظر یافت نشد", "warning");
                } else {

                    this.props.showAlert(res.data.message, "success");
                    this.setState({ collapse: false });
                    let result = res.data.data;
                    this.setState({
                        DriverFullName: result.name + " " + result.family
                        , DriverMobile: result.mobile
                        , DriverId: result.id
                        , IsActiveCard: result.isActiveCard
                        , DriverCardNumber: result.cardNumber
                        , HealthCardValidationDate: result.healthCardValidationDate
                        , CardValidationDate: result.cardValidationDatePersian
                    });
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    searchDriverBy2 = () => {
        this.props.showSpinner();
        let url = 'api/v1/drivers/GetDriverInfoByNationalIdandInquiry/'
        axios.get(url + toEnglishNumbers(this.state.DriverNationalId2))
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data === null || res.data.data.length === 0) {
                    this.props.showAlert("راننده‌ای با مشخصات مورد نظر یافت نشد", "warning");
                } else {

                    this.props.showAlert(res.data.message, "success");
                    this.setState({ collapse: false });
                    let result = res.data.data;
                    this.setState({
                        DriverFullName2: result.name + " " + result.family
                        , DriverMobile2: result.mobile
                        , DriverId2: result.id
                        , IsActiveCard2: result.isActiveCard
                        , DriverCardNumber2: result.cardNumber
                        , HealthCardValidationDate2: result.healthCardValidationDate
                        , CardValidationDate2: result.cardValidationDatePersian
                    });
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    FreighterByCardNumber = () => {
        this.props.showSpinner();
        let url = 'api/v1/drivers/GetFreighterByCardNumberandInquiry/'
        axios.get(url + toEnglishNumbers(this.state.FreighterCardNumber))
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data === null || res.data.data.length === 0) {
                    this.props.showAlert("ناوگانی با مشخصات مورد نظر یافت نشد", "warning");
                } else {

                    this.props.showAlert(res.data.message, "success");
                    this.setState({ collapse: false });
                    let result = res.data.data;
                    const plaque = result.plaqueNumber || "";
                    const selectedLoaderTypeCode =
                        this.state.loaderTypeCodes.find(
                            x => x.typeCode === result.typeCode
                        ) || null;

                    this.getLoaderTypesByCode(
                        result.typeCode,
                        result.loadingTypeCode
                    );
                    this.setState({
                        PlaqueSerialNumber: result.plaqueSerialNumber
                        , PlaqueNumber1: plaque.length >= 2 ? plaque.substring(0, 2) : ""
                        , PlaqueNumber: plaque.length >= 4 ? plaque.substring(plaque.length - 3) : ""
                        , ExaminationValidDate: result.examinationValidDate
                        , FreighterInsuranceExpireDate: result.freighterInsuranceExpireDate
                        , FreighterInsuranceNumber: result.freighterInsuranceNumber
                        , LoaderTypeId: result.loaderTypeId
                        , LoadingTypeCode: result.loadingTypeCode
                        , LoadingTypeTitle: result.loadingTypeTitle
                        , selectedLoaderTypeCode: selectedLoaderTypeCode,
                        //selectedLoaderTypes: selectedLoaderTypes
                    });
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    SendDriverPass = () => {
        const nationalId = this.state.DriverNationalId;

        // چک خالی بودن
        if (!nationalId || nationalId.toString().trim() === '') {
            this.props.showMessage('کد ملی را وارد کنید'); // یا هر متد پیام خودت
            return;
        }
        this.props.showSpinner();
        let url = 'api/v1/drafts/SendDriverPass/'
        axios.post(url, toEnglishNumbers(nationalId))
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data === null || res.data.data.length === 0) {
                    this.props.showAlert("راننده‌ای با مشخصات مورد نظر یافت نشد", "warning");
                } else {

                    this.props.showAlert(res.data.message, "success");
                    this.setState({ collapse: false });

                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    SendFreighterPass = () => {
        this.props.showSpinner();
        let url = 'api/v1/drafts/SendFreighterPass/'
        axios.post(url, toEnglishNumbers(this.state.FreighterCardNumber))
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data === null || res.data.data.length === 0) {
                    this.props.showAlert("ناوگانی‌ با مشخصات مورد نظر یافت نشد", "warning");
                } else {

                    this.props.showAlert(res.data.message, "success");
                    this.setState({ collapse: false });

                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    async getBastebandysApi() {
        try {
            await getBastebandys()
                .then((res) => this.setState({ Bastebandys: res.data }));
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }
    async getkalasApi() {
        try {
            await getkalas()
                .then((res) => this.setState({ kalas: res.data }));
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }
    async getLoaderTypesApi() {
        try {
            await getLoaderTypes()
                .then((res) => this.setState({ loaderTypes: res.data }));
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }
    async GetDistinctLoaderTypes() {
        try {

            await GetDistinctLoaderTypes()
                .then((res) => {
                    this.setState({ loaderTypeCodes: res.data });
                    //console.log("GetDistinctLoaderTypes");
                    //console.log(res.data);
                })

        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }
    getLoaderTypesByCode1 = (Code) => {
        axios.get('/api/v1/loader-types/GetLoaderTypeByCode?Code=' + Code)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ loaderTypes: res.data.data });
                //console.log("getLoaderTypesByCode");
                //console.log(res.data);
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    getLoaderTypesByCode = (typeCode, selectedLoadingTypeCode = null) => {
        axios.get('/api/v1/loader-types/GetLoaderTypeByCode?Code=' + typeCode)
            .then((res) => {
                this.props.hideSpinner();
                const loaderTypes = res.data.data || [];

                // اگر selectedLoadingTypeCode داریم، مقدار دراپ دوم رو هم ست کن
                const selectedLoaderTypes = loaderTypes.find(
                    x => x.loaderTypeCode === selectedLoadingTypeCode
                ) || null;

                this.setState({
                    loaderTypes: loaderTypes,
                    selectedLoaderTypes: selectedLoaderTypes
                });

                //console.log("getLoaderTypesByCode", res.data);
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    GetCustomerByTransportationCompanyId = () => {
        axios.get('/api/v1/customers/GetCustomerByTransportationCompanyId')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ customer: res.data.data });
                //console.log(res.data.data)
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    GetFinancialBill = () => {
        this.props.showSpinner();
        axios.post('/api/v1/financial-coefficient-defaults/SearchFinancialCoefficientDefault')
            .then(res => {
                this.props.hideSpinner();
                const data = res.data.data || [];
                this.setState({ coefficients: data });
                console.log(data)
                this.props.showAlert(
                    data.length === 0
                        ? "موردی یافت نشد"
                        : `${data.length} مورد یافت شد`,
                    data.length === 0 ? "warning" : "success"
                );
            })
            .catch(err => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(err), "error");
            });
    };
    calculate = () => {
        const {
            BaseFreightAmount,
            PreFreight,
            coefficients,
            OtherExpenses // اگر سایر هزینه‌ها هم دستی وارد می‌شود
        } = this.state;

        // ۱. استخراج عدد خالص از استیت (حذف هر چیزی که عدد نیست برای اطمینان)
        const getRawNumber = (val) => Number(toEnglishNumbers(String(val).replace(/[^0-9]/g, ""))) || 0;

        const baseFare = getRawNumber(BaseFreightAmount);
        const pishKeraye = getRawNumber(PreFreight);
        const other = getRawNumber(OtherExpenses);

        let totalAddToRent = 0;
        let totalDeductedFromDriver = 0;

        // مقادیر تکی برای نمایش در فیلدها
        let tempValues = {
            PayanehCost: 0,
            Commission: 0,
            InsuranceAmount: 0,
            RightPasokool: 0,
            SleepRight: 0,
            Darman: 0 // بیمه تکمیل درمان
        };

        // ۲. چرخش روی ضرایب لود شده از سرور
        if (coefficients && coefficients.length > 0) {
            coefficients.forEach(item => {
                let itemAmount = 0;
                const className = item.financialCoefficientClassName;

                // محاسبه مبلغ این ضریب
                if (item.isPercent) {
                    itemAmount = (baseFare * (Number(item.percentageOfRent) || 0)) / 100;
                } else if (item.isFixedAmount) {
                    itemAmount = Number(item.fixedAmount) || 0;
                }

                // مپ کردن به متغیرهای محلی بر اساس لیست Enums که دادی
                switch (className) {
                    case "Payane": tempValues.PayanehCost = itemAmount; break;
                    case "Commision": tempValues.Commission = itemAmount; break;
                    case "Bime": tempValues.InsuranceAmount = itemAmount; break;
                    case "Baskol": tempValues.RightPasokool = itemAmount; break;
                    case "SleepPrice": tempValues.SleepRight = itemAmount; break;
                    case "Darman": tempValues.Darman = itemAmount; break;
                    // اگر Bargiri یا Takhliye هم داری اینجا اضافه کن
                }

                // ۳. اعمال منطق بیزینسی (تیک‌های پنل تنظیمات)
                if (item.addToRent) {
                    totalAddToRent += itemAmount;
                }
                if (item.deductedFromDriver) {
                    totalDeductedFromDriver += itemAmount;
                }
            });
        }

        // ۴. محاسبه نهایی مبالغ پایین فرم
        // باقی‌مانده کرایه = (کرایه پایه + مبالغ "اضافه به کرایه" + سایر) - پیش کرایه
        const remaining = (baseFare + totalAddToRent + other) - pishKeraye;

        // ۵. به‌روزرسانی استیت برای اعمال در اینپوت‌ها
        this.setState({
            ...tempValues, // تمام مقادیر PayanehCost, Commission و ... یکجا آپدیت می‌شوند
            ReceivedFromDriver: totalDeductedFromDriver,
            RemainingFreight: remaining
        });
    };
    handleManualCalculate = () => {
        const { BaseFreightAmount } = this.state;

        // چک کردن اینکه مبلغ کرایه پایه وارد شده باشد
        if (!BaseFreightAmount || BaseFreightAmount === "0") {
            this.props.showAlert("لطفاً ابتدا مبلغ کرایه پایه را وارد کنید", "warning");
            return;
        }

        // اگر وارد شده بود، تابع اصلی را صدا بزن
        this.calculate();
    };
    loadSenderAddresses = (selectedId, SenderAddressId) => {
        if (selectedId) {
            axios.get('/api/v1/customer-addresses/GetCustomerAddressByCustomerId?CustomerId=' + selectedId)
                .then((res) => {
                    if (res.data.data != null && res.data.data.length > 0) {
                        if (SenderAddressId != null) {
                            this.setState({ senderAddresses: res.data.data },
                                () => res.data.data.map((v) => {
                                    if (v.id === SenderAddressId) {
                                        this.setState({ senderAddress: v },
                                            () => this.setState({ Origin: this.state.senderAddress.cityName },
                                            ))
                                    }
                                    return null
                                }));
                        } else {
                            this.setState({ senderAddresses: res.data.data },
                                () => this.setState({ senderAddress: this.state.senderAddresses[0] },
                                    () => this.setState({ SenderSourceCity: this.state.senderAddress.cityName },
                                    ))
                            );
                        }
                    } else {
                        this.setState({
                            senderAddresses: [],
                            senderAddress: null,

                            SenderSourceCity: ""
                        })
                    }
                })
                .catch((error) => {
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        }
    };
    loadReceiverAddresses = (selectedId, ReceiverAddressId) => {
        if (selectedId) {
            axios.get('/api/v1/customer-addresses/GetCustomerAddressByCustomerId?CustomerId=' + selectedId)
                .then((res) => {
                    if (res.data != null && res.data.data.length > 0) {
                        if (ReceiverAddressId != null) {
                            this.setState({ receiverAddresses: res.data.data },
                                () => res.data.data.map((v) => {
                                    if (v.id === ReceiverAddressId) {
                                        this.setState({ receiverAddress: v },
                                            () => this.setState({ Destination: this.state.receiverAddress.cityName },
                                            ))
                                    }
                                    return null
                                }));
                        } else {
                            this.setState({ receiverAddresses: res.data.data },
                                () => this.setState({ receiverAddress: this.state.receiverAddresses[0] },
                                    () => this.setState({ ReceiverDestinationCity: this.state.receiverAddress.cityName },
                                    ))
                            );
                        }
                    } else {
                        this.setState({
                            receiverAddresses: [],
                            receiverAddress: null,

                            ReceiverDestinationCity: ""
                        })
                    }
                })
                .catch((error) => {
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        }
    };


    async TransportationCompanyShippingContract() {
        await axios.get('api/v1/shipping-contracts/TransportationCompanyShippingContract')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({
                    ShippingContractList: res.data.data,

                });
                //console.log(res.data.data)
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    async TransportationCompanyKalaGroup() {
        await axios.get('api/v1/kala-groups/TransportationCompanyKalaGroup')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({
                    KalaGroupList: res.data.data,

                });
                //console.log(res.data.data)
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    async TransportationCompanyProductOwner() {
        await axios.get('api/v1/transportation-company-ProductOwners/GetTransportationCompanyProductOwnerByTransportationCompanyId')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({
                    TransportationCompanyProductOwnerList: res.data.data,

                });
                //console.log(res.data.data)
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    async TransportationCompanyInsuranceContract() {
        await axios.get('api/v1/insurance-contracts/TransportationCompanyInsuranceContract')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({
                    InsuranceContractList: res.data.data,

                });
                //console.log(res.data.data)
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };


    validateInputData = () => {
        this.props.closeSweetAlert();

        let error = [];
        let errorInputs = [];

        // ⏰ ساعت حواله
        validateTime(
            this.state.BillHour,
            this.state.BillMinute,
            "بارنامه",
            error,
            errorInputs,
            "BillOfLading"
        );
        if (
            isEmpty(this.state.BillOfLadingSeries)
        ) {
            error.push("وارد کردن شماره سریال بارنامه الزامی میباشد");
            errorInputs.push("BillOfLadingSeries");
        }
        // 🔢 شماره سفارش
        if (isInvalidNumber(this.state.BillOfLadingNumber)) {
            error.push("وارد کردن شماره بارنامه الزامی میباشد");
            errorInputs.push("BillOfLadingNumber");
        }

        // 📄 قرارداد حمل
        if (isAutocompleteEmpty(this.state.ShippingContract)) {
            error.push("انتخاب قرارداد حمل الزامی میباشد");
            errorInputs.push("ShippingContract");
        }

        if (isAutocompleteEmpty(this.state.KalaGroup)) {
            error.push("انتخاب گروه محموله الزامی میباشد");
            errorInputs.push("KalaGroup");
        }


        if (isSelectEmpty(this.state.selectedRentalType)) {
            error.push("انتخاب نوع کرایه الزامی میباشد");
            errorInputs.push("selectedRentalType");
        }
        // 🔢 شماره سفارش
        if (isInvalidNumber(this.state.OrderNumber)) {
            error.push("وارد کردن شماره سفارش الزامی میباشد");
            errorInputs.push("OrderNumber");
        }

        // 👤 فرستنده / گیرنده
        if (isAutocompleteEmpty(this.state.sender)) {
            error.push("انتخاب فرستنده الزامی میباشد");
            errorInputs.push("sender");
        }

        if (isAutocompleteEmpty(this.state.receiver)) {
            error.push("انتخاب گیرنده الزامی میباشد");
            errorInputs.push("receiver");
        }

        if (isAutocompleteEmpty(this.state.senderAddress)) {
            error.push("وارد کردن آدرس فرستنده الزامی میباشد");
            errorInputs.push("senderAddress");
        }

        if (isAutocompleteEmpty(this.state.receiverAddress)) {
            error.push("انتخاب آدرس گیرنده الزامی میباشد");
            errorInputs.push("receiverAddress");
        }

        if (
            !isAutocompleteEmpty(this.state.senderAddress) &&
            this.state.senderAddress === this.state.receiverAddress
        ) {
            error.push("آدرس گیرنده نمی‌تواند با آدرس فرستنده برابر باشد");
            errorInputs.push("senderAddress", "receiverAddress");
        }

        // 🌍 مبدا و مقصد
        if (
            isEmpty(this.state.SenderSourceCity) ||
            isEmpty(this.state.ReceiverDestinationCity)
        ) {
            error.push("وارد کردن مبدا و مقصد الزامی میباشد");
            errorInputs.push("SenderSourceCity", "ReceiverDestinationCity");
        }

        // 🚚 اطلاعات راننده
        const driverFields = [
            "DriverCardNumber",
            "DriverNationalId",
            "DriverMobile",
            "DriverFullName",
            "CardValidationDate",
            "HealthCardValidationDate"
        ];

        if (driverFields.some(f => isEmpty(this.state[f]))) {
            error.push("وارد کردن اطلاعات راننده الزامی میباشد");
            errorInputs.push("DriverNationalId");
        }

        // 🚛 اطلاعات ناوگان
        const fleetFields = [
            "FreighterCardNumber",
            "PlaqueNumber1",
            "PlaqueNumber",
            "PlaqueSerialNumber",
            "ExaminationValidDate",
            "FreighterInsuranceExpireDate",
            "FreighterInsuranceNumber"
        ];

        if (fleetFields.some(f => isEmpty(this.state[f]))) {
            error.push("وارد کردن اطلاعات ناوگان الزامی میباشد");
            errorInputs.push("FreighterCardNumber");
        }

        // 📦 کالا
        if (isAutocompleteEmpty(this.state.kala)) {
            error.push("انتخاب نوع کالا الزامی میباشد");
            errorInputs.push("kala");
        }
        if (isAutocompleteEmpty(this.state.Bastebandy)) {
            error.push("انتخاب  بسته‌بندی الزامی میباشد.");
            errorInputs.push("Bastebandy");
        }


        if (isInvalidNumber(this.state.KalaQuantity)) {
            error.push("وارد کردن تعداد الزامی میباشد");
            errorInputs.push("KalaQuantity");
        }

        if (isInvalidNumber(this.state.kalaWeight)) {
            error.push("وارد کردن وزن الزامی میباشد");
            errorInputs.push("kalaWeight");
        }

        if (isInvalidNumber(this.state.kalaValue)) {
            error.push("وارد کردن ارزش کالا الزامی میباشد");
            errorInputs.push("kalaValue");
        }
        if (isInvalidNumber(this.state.BaseFreightAmount)) {
            error.push("وارد كردن مبلغ کرایه پایه الزامی میباشد");
            errorInputs.push("BaseFreightAmount");
        }
        if (isInvalidNumber(this.state.PayanehCost)) {
            error.push("وارد كردن حق پایانه الزامی میباشد");
            errorInputs.push("PayanehCost");
        }
        if (isInvalidNumber(this.state.Commission)) {
            error.push("وارد كردن کمیسیون الزامی میباشد");
            errorInputs.push("Commission");
        }
        if (isInvalidNumber(this.state.PreFreight)) {
            error.push("وارد كردن پیش کرایه الزامی میباشد");
            errorInputs.push("PreFreight");
        }
        if (isInvalidNumber(this.state.RightPasokool)) {
            error.push("وارد كردن حق باسکول الزامی میباشد");
            errorInputs.push("RightPasokool");
        }
        if (isInvalidNumber(this.state.SleepRight)) {
            error.push("وارد كردن حق خواب الزامی میباشد");
            errorInputs.push("SleepRight");
        }

        if (isInvalidNumber(this.state.OtherExpenses)) {
            error.push("وارد كردن سایر هزینه ها الزامی میباشد");
            errorInputs.push("OtherExpenses");
        }

        if (isInvalidNumber(this.state.ReceivedFromDriver)) {
            error.push("وارد كردن دریافتی از راننده الزامی میباشد");
            errorInputs.push("ReceivedFromDriver");
        }
        if (isInvalidNumber(this.state.RemainingFreight)) {
            error.push("وارد كردن باقی مانده کرایه الزامی میباشد");
            errorInputs.push("RemainingFreight");
        }


        if (isAutocompleteEmpty(this.state.InsuranceContract)) {
            error.push("انتخاب بیمه مسئولیت الزامی میباشد");
            errorInputs.push("InsuranceContract");
        }
        if (isAutocompleteEmpty(this.state.TransportationCompanyProductOwner)) {
            error.push("انتخاب نماینده صاحب کالا الزامی میباشد.");
            errorInputs.push("TransportationCompanyProductOwner");
        }


        if (
            !this.state.selectedShippingStatus ||
            !this.state.selectedShippingStatus.value
        ) {
            error.push("انتخاب وضعیت حمل الزامی میباشد.");
            errorInputs.push("selectedShippingStatus");
        }

        if (isEmpty(this.state.EstimatedArrivalDate)) {
            error.push("انتخاب تاریخ تقریبی رسیدن الزامی میباشد");
            errorInputs.push("EstimatedArrivalDate");
        }

        this.setState({ errors: error, errorInputs });

        if (error.length === 0) {
            this.submitForm();
        } else {
            this.props.showAlert(
                "لطفاً تمامی اطلاعات درخواست شده را به درستی وارد کنید",
                "error"
            );
        }
    };

    submitForm = () => {
        const customsInformation = this.state.IsCustomsInformation
            ? {
                ContainerNumber1: this.state.ContainerNumber1 || null,
                ContainerNumber2: this.state.ContainerNumber2 || null,
                CotageNumber: this.state.CotageNumber || null,
                CotageDate: this.state.CotageDate ? convertDate(this.state.CotageDate) : null,
                ProductBarcode: this.state.ProductBarcode || null,
                CustomsSealNumber: this.state.CustomsSealNumber || null,
                CustomsPermitNumber: this.state.CustomsPermitNumber || null
            }
            : null;
        const BillPayment = this.state.IsBillPayment
            ? {
                PayerPhone: this.state.PayerPhone || null,
                PayerBirthDate: this.state.PayerBirthDate ? convertDate(this.state.PayerBirthDate) : null,
                PayerNationalId: this.state.PayerNationalId || null,
                PayerCompanyNationalId: this.state.PayerCompanyNationalId || null,
                PayerManagerNationalId: this.state.PayerManagerNationalId || null,
                PayerManagerPhone: this.state.PayerManagerPhone || null,
                PayerManagerBirthDate: this.state.PayerManagerBirthDate ? convertDate(this.state.PayerManagerBirthDate) : null,
                ReceiverNationalId: this.state.ReceiverNationalId || null,
                ReceiverPhone: this.state.ReceiverPhone || null,
                ReceiverBirthDate: this.state.ReceiverBirthDate ? convertDate(this.state.ReceiverBirthDate) : null,



            }
            : null;
        const Oil = this.state.IsOil
            ? {

                DraftOrBillNumber: this.state.DraftOrBillNumber || null,
                IssueDate: this.state.IssueDate ? convertDate(this.state.IssueDate) : null,
                Temperature: this.state.Temperature || null,
                SpecificGravity: this.state.SpecificGravity || null,
                NaturalQuantity: this.state.NaturalQuantity || null,
                Quantityat60Degrees: this.state.Quantityat60Degrees || null,
                KalaWeight: this.state.KalaWeight || null,
                RahdardiNumber: this.state.RahdardiNumber || null,
                InsuranceContractId: this.state.InsuranceContract !== null ? this.state.InsuranceContract.id : null,
            }
            : null;

        const steelInformation = this.state.IsSteelInformation
            ? [
                {
                    SteelOrderNumber: this.state.SteelOrderNumber || null,
                    StatusDraftNo: this.state.SteelDraftPosition || null,
                    PlannedWeight: this.state.SteelPlannedWeight ? toEnglishNumbers(this.state.SteelPlannedWeight) : null,
                    SteelQuantity: this.state.SteelQuantity ? toEnglishNumbers(this.state.SteelQuantity) : null,
                    CustomerName: this.state.SteelCustomerName || null,
                    CustomerCode: this.state.SteelCustomerCode || null,
                    ProductType: this.state.SteelProductType || null,
                    Mechanism: this.state.Mechanism || null,
                    ThicknessMM: this.state.SteelThickness ? toEnglishNumbers(this.state.SteelThickness) : null,
                    WidthMM: this.state.SteelWidth ? toEnglishNumbers(this.state.SteelWidth) : null,
                    LengthMM: this.state.SteelLength ? toEnglishNumbers(this.state.SteelLength) : null,
                    UsefulLength: this.state.SteelUsefulLength ? toEnglishNumbers(this.state.SteelUsefulLength) : null,
                    WarehouseRegion: this.state.SteelWarehouse || null,
                    ISG: this.state.SteelISG || null,
                    Item: this.state.SteelItem || null,
                    LoadingPointCode: this.state.SteelLoadingPoint || null,
                    SteelWaybill: this.state.SteelProgram || null,
                    SteelDesc: this.state.SteelDescription || null
                }
            ]
            : null;



        const model = {

            DraftId: this.state.draftId,
            BillOfLadingDate: convertDate(this.state.Billdate),
            BillOfLadingTime: this.state.BillHour + ":" + this.state.BillMinute,
            BillOfLadingNumber: toEnglishNumbers(this.state.BillOfLadingNumber),
            BillOfLadingSeries: this.state.BillOfLadingSeries,
            OrderNumber: toEnglishNumbers(this.state.OrderNumber),
            IsReturned: this.state.IsReturned,
            ShippingContractId: this.state.ShippingContract !== null ? this.state.ShippingContract.id : null,
            KalaGroupId: this.state.KalaGroup !== null ? this.state.KalaGroup.id : null,
            RentalType: this.state.selectedRentalType.value,
            //FreighterId: 
            FreighterCardNumber: toEnglishNumbers(this.state.FreighterCardNumber),//
            PlaqueNumber: toEnglishNumbers(this.state.PlaqueNumber1) + 'ع' + toEnglishNumbers(this.state.PlaqueNumber),
            PlaqueSerialNumber: toEnglishNumbers(this.state.PlaqueSerialNumber),
            LoaderTypeId: this.state.selectedLoaderTypes.id,
            LoaderTypeCode: this.state.selectedLoaderTypes.loaderTypeCode,//
            LoaderTypeName: this.state.selectedLoaderTypes.loaderTypeName,
            LoaderTypeDesc: this.state.selectedLoaderTypes.loaderTypeDesc,
            FreighterInsuranceNumber: toEnglishNumbers(this.state.FreighterInsuranceNumber),
            FreighterInsuranceExpireDate: convertDate(this.state.FreighterInsuranceExpireDate),
            ExaminationValidDate: (this.state.ExaminationValidDate),
            DriverCardNumber: toEnglishNumbers(this.state.DriverCardNumber),
            DriverNationalId: toEnglishNumbers(this.state.DriverNationalId),
            DriverFullName: toEnglishNumbers(this.state.DriverFullName),
            //DriverId: this.state.DriverId, 
            DriverMobile: toEnglishNumbers(this.state.DriverMobile),
            IsActiveCard: this.state.IsActiveCard,
            HealthCardValidationDate: (this.state.HealthCardValidationDate),
            CardValidationDate: (this.state.CardValidationDate),

            //DriverId2:this.state.DriverId2,
            DriverCardNumber2: toEnglishNumbers(this.state.DriverCardNumber2),
            DriverNationalId2: toEnglishNumbers(this.state.DriverNationalId2),
            DriverMobile2: toEnglishNumbers(this.state.DriverMobile2),
            DriverFullName2: toEnglishNumbers(this.state.DriverFullName2),
            IsActiveCard2: this.state.IsActiveCard2,
            HealthCardValidationDate2: (this.state.HealthCardValidationDate2),
            CardValidationDate2: (this.state.CardValidationDate2),
            SenderCustomerAddressId: this.state.senderAddress ? this.state.senderAddress.id : "0",
            SenderCustomerId: this.state.sender ? this.state.sender.id : "0",
            SenderName: this.state.sender ? this.state.sender.customerName : "",
            SenderFamily: this.state.sender ? this.state.sender.customerFamily : "",
            SenderNationalID: this.state.sender ? this.state.sender.meliCode : "",
            SenderSourceCityId: this.state.senderAddress ? this.state.senderAddress.cityId : "0",
            SenderPostalCode: this.state.senderAddress ? this.state.senderAddress.postalCode : "",
            SenderAddress: this.state.senderAddress ? this.state.senderAddress.address : "",
            SenderSourceCityName: this.state.senderAddress ? this.state.senderAddress.cityName : "",
            SenderSourceCityCode: this.state.senderAddress ? this.state.senderAddress.cityCode : "",
            ReceiverCustomerId: this.state.receiver ? this.state.receiver.id : "0",
            ReceiverCustomerAddressId: this.state.receiverAddress ? this.state.receiverAddress.id : "0",
            ReceiverName: this.state.receiver ? this.state.receiver.customerName : "",
            ReceiverFamily: this.state.receiver ? this.state.receiver.customerFamily : "",
            ReceiverNationalID: this.state.receiver ? this.state.receiver.meliCode : "",
            ReceiverDestinationCityId: this.state.receiverAddress ? this.state.receiverAddress.cityId : 0,

            ReceiverPostalCode: this.state.receiverAddress ? this.state.receiverAddress.postalCode : "",
            ReceiverAddress: this.state.receiverAddress ? this.state.receiverAddress.address : "",
            ReceiverDestinationCityName: this.state.receiverAddress ? this.state.receiverAddress.cityName : "",
            ReceiverDestinationCityCode: this.state.receiverAddress ? this.state.receiverAddress.cityCode : "",
            LogesticCode: this.state.kala.logesticCode,
            KalaId: this.state.kala.id,
            KalaCode: this.state.kala.kalaCode,
            KalaDesc: this.state.KalaDesc,
            KalaNote: this.state.KalaNote,
            BastebandyId: this.state.Bastebandy.id,
            BastebandyCode: this.state.Bastebandy.code,
            KalaWeight: toEnglishNumbers(this.state.kalaWeight),
            KalaValue: (this.state.kalaValue !== null && this.state.kalaValue !== undefined && this.state.kalaValue !== "") ? toEnglishNumbers(this.state.kalaValue) : null,
            KalaQuantity: toEnglishNumbers(this.state.KalaQuantity),

            ShippingStatus: this.state.selectedShippingStatus.value,
            BaseFreightAmount: toEnglishNumbers(this.state.BaseFreightAmount),
            PreFreight: toEnglishNumbers(this.state.PreFreight),
            PayanehCost: toEnglishNumbers(this.state.PayanehCost),
            Commission: toEnglishNumbers(this.state.Commission),

            InsuranceAmount: toEnglishNumbers(this.state.InsuranceAmount),
            RightPasokool: toEnglishNumbers(this.state.RightPasokool),
            SleepRight: toEnglishNumbers(this.state.SleepRight),
            OtherExpenses: toEnglishNumbers(this.state.OtherExpenses),
            ReceivedFromDriver: toEnglishNumbers(this.state.ReceivedFromDriver),
            RemainingFreight: toEnglishNumbers(this.state.RemainingFreight),
            TransportationCompanyProductOwnerId: this.state.TransportationCompanyProductOwner !== null ? this.state.TransportationCompanyProductOwner.id : null,//
            InsuranceContractId: this.state.InsuranceContract !== null ? this.state.InsuranceContract.id : null,
            InsuranceCode: this.state.InsuranceContract !== null ? this.state.InsuranceContract.amount : null,

            EstimatedArrivalDate: convertDate(this.state.EstimatedArrivalDate),
            Desc: toEnglishNumbers(this.state.Desc),
            Rubari: this.state.Rubari,
            Id: this.state.BillId,
            HavalehTraceCode: this.state.HavalehTraceCode,
            // DriverPassword: toEnglishNumbers(this.state.DriverPassword),
            //  FreighterPassword: toEnglishNumbers(this.state.FreighterPassword),
            CustomsInformation: customsInformation,
            SteelInformation: steelInformation,
            BillPayment: BillPayment,
            Oil: Oil,
            SmallCargo: null,
            RefuelingRoute: null,

        };


        this.props.showSpinner();
        axios.post('/api/v1/bill-of-ladings/AddBill', model)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    //this.props.showAlert("اعلام بار با شناسه " + res.data + " با موفقیت ثبت شد", "success");
                    this.props.showAlert(res.data.message, "success");
                    if (res.data.data.result.code === null) {

                        this.setState({ BillId: res.data.data.result.result });
                    }

                    this.props.history.push('/Bills');
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    loadProvinces = () => {
        this.props.showSpinner();
        axios.get('api/HelperApi/GetProvinces')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ provinces: res.data });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    selectHandleChange = (event, value, name) => {

        if (name === "kala") {
            if (value !== undefined && value !== null) {
                this.setState({ KalaDesc: value.kalaDesc },
                );
            }
        }
        if (name === "sender") {

            if (value !== undefined && value !== null) {
                this.setState({ senderAddress: null },
                    () => this.loadSenderAddresses(value.id, null));
            }
            else {
                this.setState({
                    senderAddress: null,
                    senderAddresses: [],
                    SenderSourceCity: "",

                })
            }

        }
        else if (name === "senderAddress") {
            if (value !== undefined && value !== null) {
                this.setState({ SenderSourceCity: value.cityBol ? value.cityBol.cityName : value.cityName },
                );
            }
            else {
                this.setState({

                    ReceiverDestinationCity: "",

                })
            }
        }
        else if (name === "receiver") {
            if (value !== undefined && value !== null) {
                this.setState({ receiverAddress: null },
                    () => this.loadReceiverAddresses(value.id, null));
            }
            else {
                this.setState({
                    receiverAddress: null,
                    receiverAddresses: [],
                    ReceiverDestinationCity: "",

                })
            }
        }
        else if (name === "receiverAddress") {
            if (value !== undefined && value !== null) {
                this.setState({ ReceiverDestinationCity: value.cityBol ? value.cityBol.cityName : value.cityName },
                );
            }
            else {
                this.setState({

                    ReceiverDestinationCity: "",

                })
            }
        }



        if (name === "selectedLoaderTypeCode") {
            if (value && value.typeCode) {
                // وقتی دراپ اول تغییر کرد، دومی رو خالی می‌کنیم
                this.setState({ selectedLoaderTypes: null }, () => {
                    // سپس داده‌ها را برای دومی لود می‌کنیم
                    this.getLoaderTypesByCode(value.typeCode);
                });
            } else {
                this.setState({ selectedLoaderTypes: null, loaderTypes: [] });
            }

            // مقدار خود دراپ اول را هم ست می‌کنیم
            this.setState({ selectedLoaderTypeCode: value });
        }



        this.setState({ [name]: value });
    };

    OptionsMenuClick = (event, id) => {
        this.setState({ [id]: event.currentTarget });
    };
    OptionsMenuClose = (id) => {
        this.setState({ [id]: null });
    };
    openCustomerModal = (modalName, id) => {
        if (modalName === "addCustomerModal" || modalName === "manageCustomerModal") {
            if (this.state.provinces.length === 0) {
                this.loadProvinces();
            }
        }

        if (modalName === "editCustomerModal" || modalName === "manageCustomerModal") {
            if (id === "receiverOptionsMenu") {
                this.state.currentCustomer = this.state.receiver;
            } else if (id === "senderOptionsMenu") {
                this.state.currentCustomer = this.state.sender;
            }
        }

        this.setState({
            [modalName]: true,
            [id]: null
        });
    }
    closeModal = (modalName) => {
        if (modalName === "addCustomerModal") {
            this.GetCustomerByTransportationCompanyId();
        }

        this.setState({ [modalName]: false });
    };

    //openSteelInformationModal = () => {
    //    this.setState({ SteelInformationModal: true });
    //};

    //openCustomsInformationModal = () => {
    //    this.setState({ CustomsInformationModal: true });
    //};
    SaveSteelInformation = () => {
        const steelErrors = [];
        const steelErrorInputs = [];

        if (isEmpty(this.state.SteelPlannedWeight)) {
            steelErrors.push("وارد کردن وزن برنامه‌ریزی شده الزامی می‌باشد");
            steelErrorInputs.push("SteelPlannedWeight");
        }

        if (isEmpty(this.state.SteelQuantity)) {
            steelErrors.push("وارد کردن تعداد الزامی می‌باشد");
            steelErrorInputs.push("SteelQuantity");
        }

        // اگر خطا داریم → فقط داخل مودال نشان بده
        if (steelErrors.length > 0) {
            this.setState({
                steelErrors,
                steelErrorInputs
            });
            return;
        }

        // اگر اوکی بود
        this.setState({
            steelErrors: [],
            steelErrorInputs: [],
            IsSteelInformation: true,
            SteelInformationModal: false
        });
    };

    SaveOil = () => {
        const oilErrors = [];
        const oilErrorInputs = [];

        if (isEmpty(this.state.DraftOrBillNumber)) {
            oilErrors.push("وارد کردن شماره بارنامه یا حواله الزامی می‌باشد");
            oilErrorInputs.push("SteelPlannedWeight");
        }
        
        if (isEmpty(this.state.IssueDate)) {
            oilErrors.push("انتخاب تاریخ صدور الزامی میباشد");
            oilErrorInputs.push("IssueDate");
        }
        if (isEmpty(this.state.NaturalQuantity)) {
            oilErrors.push("وارد کردن مقدار طبیعی (لیتر الزامی می‌باشد");
            oilErrorInputs.push("NaturalQuantity");
        }
        if (isEmpty(this.state.SpecificGravity)) {
            oilErrors.push("وارد کردن مقدار  وزن مخصوص الزامی می‌باشد");
            oilErrorInputs.push("SpecificGravity");
        }

        // اگر خطا داریم → فقط داخل مودال نشان بده
        if (oilErrors.length > 0) {
            this.setState({
                oilErrors,
                oilErrorInputs
            });
            return;
        }

        // اگر اوکی بود
        this.setState({
            oilErrors: [],
            oilErrorInputs: [],
            IsOil: true,
            OilModal: false
        });
    };


    render() {
        const {
            errors, Rubari, IsReturned, BillOfLadingNumber, BillOfLadingSeries,
            selectedRentalType, RentalType, Billdate, BillHour, BillMinute,
            OrderNumber, ShippingContractList, ShippingContract, KalaGroupList, KalaGroup,
            sender, customer, senderAddresses, senderAddress, SenderSourceCity,
            receiver, receiverAddresses, receiverAddress, ReceiverDestinationCity,
            DriverNationalId, DriverPassword, DriverFullName, DriverMobile,
            DriverNationalId2, DriverFullName2, DriverMobile2,
            IsActiveCard, HealthCardValidationDate, CardValidationDate,
            FreighterCardNumber, FreighterPassword, PlaqueNumber1, PlaqueNumber,
            PlaqueSerialNumber, FreighterInsuranceNumber, FreighterInsuranceExpireDate,
            ExaminationValidDate, selectedLoaderTypeCode, loaderTypeCodes,
            selectedLoaderTypes, loaderTypes, kala, kalas, KalaNote,
            Bastebandy, Bastebandys, kalaWeight, kalaValue, KalaQuantity,
            BaseFreightAmount, PreFreight, PayanehCost, Commission, InsuranceAmount, RightPasokool, SleepRight, OtherExpenses, ReceivedFromDriver, RemainingFreight,
            TransportationCompanyProductOwnerList,
            TransportationCompanyProductOwner, InsuranceContractList, InsuranceContract,
            selectedShippingStatus, ShippingStatus, EstimatedArrivalDate, Desc,
            ContainerNumber1, ContainerNumber2, CotageNumber, CotageDate, ProductBarcode, CustomsSealNumber, CustomsPermitNumber,
            DriverTotal, TotalFare,
            PayerPhone, PayerBirthDate, PayerNationalId, PayerCompanyNationalId, PayerManagerNationalId
            , PayerManagerPhone, PayerManagerBirthDate, ReceiverNationalId, ReceiverPhone, ReceiverBirthDate,
            DraftOrBillNumber, IssueDate, Temperature, SpecificGravity, NaturalQuantity,
            Quantityat60Degrees, KalaWeight, RahdardiNumber, OilInsuranceContract,

        } = this.state;
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3 className="mb-4">ثبت بارنامه جدید</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                {/* بخش 1: اطلاعات اصلی حواله */}
                <Row className="mb-4">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody>
                                <CardTitle>اطلاعات حواله</CardTitle>
                                <Row>
                                    <Colxx md="3" sm="6">
                                        <FormGroup>
                                            <Label>شماره بارنامه</Label>
                                            <Input value={BillOfLadingNumber}
                                                onChange={e => this.setState({ BillOfLadingNumber: toEnglishNumbers(e.target.value.replace(/[^0-9]/g, "")) })}
                                                placeholder="مثال: ۱۲۳۴۵۶۷۸۹" />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx md="3" sm="6">
                                        <FormGroup>
                                            <Label>سری بارنامه</Label>

                                            <Input
                                                value={BillOfLadingSeries}
                                                onChange={e => {
                                                    let value = toEnglishNumbers(e.target.value);

                                                    // فقط عدد
                                                    value = value.replace(/[^0-9]/g, "");

                                                    // حداکثر 4 رقم
                                                    value = value.slice(0, 4);

                                                    // اضافه کردن /
                                                    if (value.length > 2) {
                                                        value = value.slice(0, 2) + "/" + value.slice(2);
                                                    }

                                                    this.setState({ BillOfLadingSeries: value });
                                                }}
                                                placeholder="مثال: 11/22"
                                            />

                                        </FormGroup>
                                    </Colxx>
                                    <Colxx md="3" sm="6">
                                        <FormGroup>
                                            <Label>تاریخ بارنامه</Label>
                                            <DatePicker
                                                value={Billdate}
                                                onChange={d => this.setState({ Billdate: d })}
                                                inputClassName="form-control"
                                                locale="fa"
                                                colorPrimary={Config.color}
                                            />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx md="2" sm="4">
                                        <FormGroup>
                                            <Label>ساعت بارنامه</Label>
                                            <div className="d-flex">
                                                <Input
                                                    value={BillMinute}
                                                    placeholder="دقیقه"
                                                    className="text-center"
                                                    onChange={e => this.setState({ BillMinute: e.target.value.replace(/[^0-9۰-۹]/g, "").slice(0, 2) })}
                                                />
                                                <span className="mx-2 mt-2">:</span>
                                                <Input
                                                    value={BillHour}
                                                    placeholder="ساعت"
                                                    className="text-center"
                                                    onChange={e => this.setState({ BillHour: e.target.value.replace(/[^0-9۰-۹]/g, "").slice(0, 2) })}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx md="2" sm="4">
                                        <FormGroup className="d-flex align-items-end">
                                            <CustomInput
                                                checked={Rubari}
                                                onChange={() => this.setState({ Rubari: !Rubari })}
                                                type="checkbox"
                                                id="Rubari"
                                                label="روباری"
                                            />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx md="2" sm="4">
                                        <FormGroup className="d-flex align-items-end">
                                            <CustomInput
                                                checked={IsReturned}
                                                onChange={() => this.setState({ IsReturned: !IsReturned })}
                                                type="checkbox"
                                                id="IsReturned"
                                                label="بارنامه برگشتی"
                                            />
                                        </FormGroup>
                                    </Colxx>
                                </Row>

                                <Row className="mt-3">
                                    <Colxx md="4">
                                        <FormGroup>
                                            <Label>قرارداد حمل</Label>
                                            <Autocomplete
                                                options={ShippingContractList}
                                                value={ShippingContract}
                                                getOptionLabel={o => o.shippingContractTitle + ' - ' + o.shippingContractNumber}
                                                onChange={(e, v) => this.selectHandleChange(e, v, "ShippingContract")}
                                                renderInput={params => <TextField {...params} variant="outlined" size="small" />}
                                            />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx md="4">
                                        <FormGroup>
                                            <Label>نوع کرایه</Label>
                                            <Autocomplete
                                                options={RentalType}
                                                value={selectedRentalType}
                                                getOptionLabel={opt => opt.text}
                                                onChange={(e, v) => this.selectHandleChange(e, v, "selectedRentalType")}
                                                renderInput={params => <TextField {...params} variant="outlined" size="small" />}
                                            />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx md="4">
                                        <FormGroup>
                                            <Label>شماره سفارش</Label>
                                            <Input
                                                value={OrderNumber}
                                                onChange={e => this.setState({ OrderNumber: e.target.value.replace(/[^0-9۰-۹]/g, "") })}
                                            />
                                        </FormGroup>
                                    </Colxx>
                                </Row>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                {/* بخش 2: فرستنده و گیرنده */}
                <Row className="mb-4">
                    <Colxx md="6">
                        <Card>
                            <CardBody>
                                <CardTitle className="d-flex justify-content-between align-items-center">
                                    فرستنده
                                    <Button size="sm" outline color="primary" onClick={e => this.OptionsMenuClick(e, 'senderOptionsMenu')}>
                                        <i className="iconsminds-gear" />
                                    </Button>
                                </CardTitle>
                                {/* منو تنظیمات مثل قبل */}
                                <Menu anchorEl={this.state.senderOptionsMenu} open={Boolean(this.state.senderOptionsMenu)} onClose={() => this.OptionsMenuClose('senderOptionsMenu')}>
                                    {/* ... آیتم‌های منو */}
                                    <MenuItem onClick={() => this.openCustomerModal('addCustomerModal', 'senderOptionsMenu')}>ایجاد فرستنده</MenuItem>
                                    {this.state.sender != null ?
                                        <>
                                            <MenuItem onClick={() => this.openCustomerModal('editCustomerModal', 'senderOptionsMenu')}>ویرایش اطلاعات فرستنده</MenuItem>
                                            <MenuItem onClick={() => this.openCustomerModal('manageCustomerModal', 'senderOptionsMenu')}>مدیریت آدرس‌های فرستنده</MenuItem>
                                        </>
                                        :
                                        null
                                    }
                                    <MenuItem onClick={() => this.openCustomerModal('manageCustomersModal', 'senderOptionsMenu')}>مدیریت مشتریان</MenuItem>
                                </Menu>

                                <FormGroup>
                                    <Label>نام فرستنده (اختیاری)</Label>
                                    <Autocomplete
                                        options={customer}
                                        value={sender}
                                        getOptionLabel={o => o.customerFullName + ' (' + o.meliCode + ')'}
                                        onChange={(e, v) => this.selectHandleChange(e, v, "sender")}
                                        renderInput={params => <TextField {...params} variant="outlined" size="small" />}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>آدرس فرستنده</Label>
                                    <Autocomplete
                                        options={senderAddresses}
                                        value={senderAddress}
                                        getOptionLabel={o => o.address + ' (پست: ' + o.postalCode + ')'}
                                        onChange={(e, v) => this.selectHandleChange(e, v, "senderAddress")}
                                        renderInput={params => <TextField {...params} variant="outlined" size="small" />}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>شهر مبدأ</Label>
                                    <Input value={SenderSourceCity} readOnly />
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </Colxx>

                    <Colxx md="6">
                        <Card>
                            <CardBody>
                                <CardTitle className="d-flex justify-content-between align-items-center">
                                    گیرنده
                                    <Button size="sm" outline color="primary" onClick={e => this.OptionsMenuClick(e, 'receiverOptionsMenu')}>
                                        <i className="iconsminds-gear" />
                                    </Button>
                                </CardTitle>
                                {/* منو گیرنده مثل قبل */}
                                <Menu
                                    id="sender-menu"
                                    MenuListProps={{ 'aria-labelledby': 'fade-button', }}
                                    anchorEl={this.state.receiverOptionsMenu}
                                    open={this.state.receiverOptionsMenu}
                                    onClose={() => this.OptionsMenuClose('receiverOptionsMenu')}
                                >
                                    <MenuItem onClick={() => this.openCustomerModal('addCustomerModal', 'receiverOptionsMenu')}>ایجاد گیرنده</MenuItem>
                                    {this.state.receiver != null ?
                                        <>
                                            <MenuItem onClick={() => this.openCustomerModal('editCustomerModal', 'receiverOptionsMenu')}>ویرایش اطلاعات گیرنده</MenuItem>
                                            <MenuItem onClick={() => this.openCustomerModal('manageCustomerModal', 'receiverOptionsMenu')}>مدیریت آدرس‌های گیرنده</MenuItem>
                                        </>
                                        :
                                        null
                                    }
                                    <MenuItem onClick={() => this.openCustomerModal('manageCustomersModal', 'receiverOptionsMenu')}>مدیریت مشتریان</MenuItem>
                                </Menu>


                                <FormGroup>
                                    <Label>نام گیرنده (اختیاری)</Label>
                                    <Autocomplete
                                        options={customer}
                                        value={receiver}
                                        getOptionLabel={o => o.customerFullName + ' (' + o.meliCode + ')'}
                                        onChange={(e, v) => this.selectHandleChange(e, v, "receiver")}
                                        renderInput={params => <TextField {...params} variant="outlined" size="small" />}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>آدرس گیرنده</Label>
                                    <Autocomplete
                                        options={receiverAddresses}
                                        value={receiverAddress}
                                        getOptionLabel={o => o.address + ' (پست: ' + o.postalCode + ')'}
                                        onChange={(e, v) => this.selectHandleChange(e, v, "receiverAddress")}
                                        renderInput={params => <TextField {...params} variant="outlined" size="small" />}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>شهر مقصد</Label>
                                    <Input value={ReceiverDestinationCity} readOnly />
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                {/* بخش 3: راننده و راننده دوم */}
                <Row className="mb-4">
                    {/* راننده اصلی */}
                    <Colxx md="6">
                        <Card className="h-100">
                            <CardBody>
                                <CardTitle className="mb-4">
                                    <i className="iconsminds-male mr-2 text-primary" />
                                    راننده اصلی
                                </CardTitle>

                                <Row>
                                    <Colxx md="8" sm="12">
                                        <FormGroup>
                                            <Label>کد ملی راننده</Label>
                                            <Input
                                                value={this.state.DriverNationalId}
                                                onChange={(e) => this.setState({ DriverNationalId: toEnglishNumbers(e.target.value.replace(/[^0-9]/g, "")) })}
                                                maxLength="10"
                                                placeholder="مثال: ۰۰۱۲۳۴۵۶۷۸"
                                            />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx md="4" sm="12" className="d-flex align-items-end">
                                        <Button
                                            color="primary"
                                            outline
                                            block
                                            className="mb-2"
                                            onClick={this.searchDriverBy}
                                        >
                                            <i className="iconsminds-magnifi-glass" /> جستجو
                                        </Button>
                                    </Colxx>
                                </Row>

                                <Row>
                                    <Colxx sm="6">
                                        <FormGroup>
                                            <Label>نام و نام خانوادگی</Label>
                                            <Input value={DriverFullName} readOnly className="bg-light" />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm="6">
                                        <FormGroup>
                                            <Label>شماره موبایل</Label>
                                            <Input value={DriverMobile} readOnly className="bg-light" />
                                        </FormGroup>
                                    </Colxx>
                                </Row>

                                <Row>
                                    <Colxx sm="6">
                                        <FormGroup>
                                            <Label>تاریخ اعتبار کارت هوشمند</Label>
                                            <Input value={CardValidationDate} readOnly className="bg-light" />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm="6">
                                        <FormGroup>
                                            <Label>تاریخ اعتبار کارت سلامت</Label>
                                            <Input value={HealthCardValidationDate} readOnly className="bg-light" />
                                        </FormGroup>
                                    </Colxx>
                                </Row>

                                <Row>
                                    <Colxx xs="12">
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <span>وضعیت کارت هوشمند:</span>
                                            <span className={`badge badge-pill ${IsActiveCard ? 'badge-success' : 'badge-danger'}`}>
                                                {IsActiveCard ? 'فعال' : 'غیرفعال'}
                                            </span>
                                        </div>
                                        <Button
                                            color="info"
                                            size="sm"
                                            outline
                                            className="mt-3"
                                            onClick={this.SendDriverPass}
                                            disabled={!DriverNationalId}
                                        >
                                            ارسال رمز عبور به راننده
                                        </Button>
                                    </Colxx>
                                </Row>
                            </CardBody>
                        </Card>
                    </Colxx>

                    {/* راننده دوم (اختیاری) */}
                    <Colxx md="6">
                        <Card className="h-100 border-dashed"> {/* border-dashed برای نشان دادن اختیاری بودن */}
                            <CardBody>
                                <CardTitle className="mb-4">
                                    <i className="iconsminds-male mr-2 text-muted" />
                                    راننده دوم <small className="text-muted">(اختیاری)</small>
                                </CardTitle>

                                <Row>
                                    <Colxx md="8" sm="12">
                                        <FormGroup>
                                            <Label>کد ملی راننده دوم</Label>
                                            <Input
                                                value={this.state.DriverNationalId2}
                                                onChange={(e) => this.setState({ DriverNationalId2: toEnglishNumbers(e.target.value.replace(/[^0-9]/g, "")) })}
                                                maxLength="10"
                                                placeholder="در صورت وجود وارد کنید"
                                            />
                                        </FormGroup>

                                    </Colxx>
                                    <Colxx md="4" sm="12" className="d-flex align-items-end">
                                        <Button
                                            color="primary"
                                            outline
                                            block
                                            className="mb-2"
                                            onClick={this.searchDriverBy2}
                                            disabled={!this.state.DriverNationalId2}
                                        >
                                            <i className="iconsminds-magnifi-glass" /> جستجو
                                        </Button>
                                    </Colxx>
                                </Row>

                                <Row>
                                    <Colxx sm="6">
                                        <FormGroup>
                                            <Label>نام و نام خانوادگی</Label>
                                            <Input value={DriverFullName2} readOnly className="bg-light" />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm="6">
                                        <FormGroup>
                                            <Label>شماره موبایل</Label>
                                            <Input value={DriverMobile2} readOnly className="bg-light" />
                                        </FormGroup>
                                    </Colxx>
                                </Row>

                                <Row>
                                    <Colxx sm="6">
                                        <FormGroup>
                                            <Label>تاریخ اعتبار کارت هوشمند</Label>
                                            <Input value={this.state.CardValidationDate2} readOnly className="bg-light" />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm="6">
                                        <FormGroup>
                                            <Label>تاریخ اعتبار کارت سلامت</Label>
                                            <Input value={this.state.HealthCardValidationDate2} readOnly className="bg-light" />
                                        </FormGroup>
                                    </Colxx>
                                </Row>

                                <Row>
                                    <Colxx xs="12">
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <span>وضعیت کارت هوشمند:</span>
                                            <span className={`badge badge-pill ${this.state.IsActiveCard2 ? 'badge-success' : 'badge-danger'}`}>
                                                {this.state.IsActiveCard2 ? 'فعال' : 'غیرفعال'}
                                            </span>
                                        </div>
                                    </Colxx>
                                </Row>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                {/* بخش 4: ناوگان */}
                <Row className="mb-4">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody>
                                <CardTitle>
                                    <i className="iconsminds-truck mr-2 text-primary" />
                                    ناوگان
                                </CardTitle>

                                <Row>
                                    <Colxx md="4" sm="12">
                                        <FormGroup>
                                            <Label>شماره کارت ناوگان</Label>
                                            <div className="d-flex">
                                                <Input value={FreighterCardNumber}
                                                    onChange={e => this.setState({ FreighterCardNumber: toEnglishNumbers(e.target.value.replace(/[^0-9]/g, "")) })}
                                                    placeholder="مثال: ۱۲۳۴۵۶۷۸۹" />
                                                <Button color="primary" outline className="ml-2" onClick={this.FreighterByCardNumber}>
                                                    جستجو
                                                </Button>
                                            </div>
                                        </FormGroup>
                                    </Colxx>

                                    <Colxx md="4" sm="12">
                                        <FormGroup>
                                            <Label>پلاک ایران</Label>
                                            <div className="d-flex align-items-center">
                                                <Input value={PlaqueNumber1} className="text-center" style={{ width: '60px' }} readOnly />
                                                <Input value={PlaqueNumber} className="text-center mx-2" style={{ width: '80px' }} readOnly />
                                                <span className="mx-1 font-weight-bold">ایران</span>
                                                <Input value={PlaqueSerialNumber} className="text-center" style={{ width: '60px' }} readOnly />
                                            </div>
                                        </FormGroup>
                                    </Colxx>

                                    <Colxx md="4">

                                        <FormGroup>
                                            <Label>*بارگیر</Label>
                                            <Autocomplete
                                                options={loaderTypeCodes}
                                                value={selectedLoaderTypeCode}
                                                getOptionLabel={o => o.loaderTypeName}

                                                onChange={(e, v) => this.selectHandleChange(e, v, "selectedLoaderTypeCode")}
                                                renderInput={params => <TextField {...params} variant="outlined" size="small" />}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <Label>*بارگیرهای مورد نیاز</Label>
                                            <Autocomplete
                                                options={loaderTypes}
                                                value={selectedLoaderTypes}
                                                getOptionLabel={o => o.loaderTypeName + " " + o.loaderTypeDesc}
                                                onChange={(e, v) => this.selectHandleChange(e, v, "selectedLoaderTypes")}
                                                renderInput={params => <TextField {...params} variant="outlined" size="small" />}
                                            />
                                        </FormGroup>

                                    </Colxx>
                                </Row>

                                <Row className="mt-3">
                                    <Colxx sm="4">
                                        <FormGroup>
                                            <Label>تاریخ معاینه فنی</Label>
                                            <Input value={ExaminationValidDate} readOnly className="bg-light" />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm="4">
                                        {/*<FormGroup>*/}
                                        {/*  <Label>تاریخ بیمه باربری</Label>*/}
                                        {/*  <Input value={FreighterInsuranceExpireDate}   className="bg-light" />*/}
                                        {/*</FormGroup>*/}

                                        <FormGroup>
                                            <Label>تاریخ بیمه باربری</Label>
                                            <DatePicker value={FreighterInsuranceExpireDate} onChange={d => this.setState({ FreighterInsuranceExpireDate: d })}
                                                inputClassName="form-control" locale="fa" />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm="4">
                                        {/*<FormGroup>*/}
                                        {/*    <Label>شماره بیمه</Label>*/}
                                        {/*    <Input value={FreighterInsuranceNumber} className="bg-light" />*/}
                                        {/*</FormGroup>*/}
                                        <FormGroup>
                                            <Label>شماره بیمه</Label>
                                            <Input value={FreighterInsuranceNumber}
                                                onChange={e => this.setState({ FreighterInsuranceNumber: e.target.value })} />
                                        </FormGroup>
                                    </Colxx>
                                </Row>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                {/* بخش 5: کالا و بسته‌بندی */}
                <Row className="mb-4">
                    <Colxx md="6">
                        <Card>
                            <CardBody>
                                <CardTitle>کالا</CardTitle>
                                <FormGroup>
                                    <Label>نوع کالا</Label>
                                    <Autocomplete options={kalas} value={kala}
                                        getOptionLabel={o => o.kalaDesc + "-" + o.logesticDesc}
                                        onChange={(e, v) => this.selectHandleChange(e, v, "kala")}
                                        renderInput={params => <TextField {...params} variant="outlined" size="small" />} />
                                </FormGroup>
                                <Row>
                                    <Colxx sm="6">
                                        <FormGroup>
                                            <Label>ارزش کالا (تومان)</Label>
                                            <Input value={toCurrency(kalaValue)}
                                                onChange={e => this.setState({ kalaValue: e.target.value.replace(/[^0-9]/g, "") })} />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm="6">
                                        <FormGroup>
                                            <Label>وزن (تن)</Label>
                                            <Input value={kalaWeight}
                                                onChange={e => this.setState({ kalaWeight: e.target.value.replace(/[^0-9.]/g, "") })} />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm="6">
                                        <FormGroup>
                                            <Label>تعداد</Label>
                                            <Input value={KalaQuantity}
                                                onChange={e => this.setState({ KalaQuantity: e.target.value.replace(/[^0-9]/g, "") })} />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx sm="6">
                                        <FormGroup>
                                            <Label>یادداشت کالا</Label>
                                            <Input value={KalaNote} type="textarea" rows="2"
                                                onChange={e => this.setState({ KalaNote: e.target.value })} />
                                        </FormGroup>
                                    </Colxx>
                                </Row>

                            </CardBody>
                        </Card>
                    </Colxx>

                    <Colxx md="6">
                        <Card>
                            <CardBody>
                                <CardTitle>بسته‌بندی</CardTitle>
                                <FormGroup>
                                    <Label>نوع بسته‌بندی</Label>
                                    <Autocomplete options={Bastebandys} value={Bastebandy}
                                        getOptionLabel={o => o.name}
                                        onChange={(e, v) => this.selectHandleChange(e, v, "Bastebandy")}
                                        renderInput={params => <TextField {...params} variant="outlined" size="small" />} />
                                </FormGroup>
                                <FormGroup>
                                    <Label>گروه محموله</Label>
                                    <Autocomplete
                                        options={KalaGroupList}
                                        value={KalaGroup}
                                        getOptionLabel={o => o.groupName}
                                        onChange={(e, v) => this.selectHandleChange(e, v, "KalaGroup")}
                                        renderInput={params => <TextField {...params} variant="outlined" size="small" />}
                                    />
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </Colxx>

                </Row>

                {/* بخش 6: کرایه و بارگیری */}



                <Row className="mb-4">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody>
                                <CardTitle>کرایه</CardTitle>

                                <Row>
                                    <Colxx md="3" sm="6">
                                        <FormGroup>
                                            <Label>مبلغ کرایه پایه</Label>
                                            <Input
                                                value={toCurrency(BaseFreightAmount)}
                                                onChange={this.handleChange("BaseFreightAmount")}
                                                onBlur={this.calculate}
                                            />
                                        </FormGroup>
                                    </Colxx>

                                    <Colxx md="3" sm="6">
                                        <FormGroup>
                                            <Label>پیش کرایه</Label>
                                            <Input
                                                value={toCurrency(PreFreight)}
                                                onChange={this.handleChange("PreFreight")}
                                                onBlur={this.calculate}
                                            />
                                        </FormGroup>
                                    </Colxx>

                                    <Colxx md="3">
                                        <FormGroup>
                                            <Label>حق پایانه</Label>
                                            <Input
                                                value={toCurrency(PayanehCost)}
                                                onChange={this.handleChange("PayanehCost")}
                                                onBlur={this.calculate}
                                            />
                                        </FormGroup>
                                    </Colxx>

                                    <Colxx md="3">
                                        <FormGroup>
                                            <Label>کمیسیون</Label>
                                            <Input
                                                value={toCurrency(Commission)}
                                                onChange={this.handleChange("Commission")}
                                                onBlur={this.calculate}
                                            />
                                        </FormGroup>
                                    </Colxx>
                                </Row>

                                <Row className="mt-3">
                                    <Colxx md="3">
                                        <FormGroup>
                                            <Label>مبلغ بیمه</Label>
                                            <Input
                                                value={toCurrency(InsuranceAmount)}
                                                onChange={this.handleChange("InsuranceAmount")}
                                                onBlur={this.calculate}
                                            />
                                        </FormGroup>
                                    </Colxx>

                                    <Colxx md="3">
                                        <FormGroup>
                                            <Label>حق باسکول</Label>
                                            <Input
                                                value={toCurrency(RightPasokool)}
                                                onChange={this.handleChange("RightPasokool")}
                                                onBlur={this.calculate}
                                            />
                                        </FormGroup>
                                    </Colxx>

                                    <Colxx md="3">
                                        <FormGroup>
                                            <Label>حق خواب</Label>
                                            <Input
                                                value={toCurrency(SleepRight)}
                                                onChange={this.handleChange("SleepRight")}
                                                onBlur={this.calculate}
                                            />
                                        </FormGroup>
                                    </Colxx>

                                    <Colxx md="3">
                                        <FormGroup>
                                            <Label>سایر</Label>
                                            <Input
                                                value={toCurrency(OtherExpenses)}
                                                onChange={this.handleChange("OtherExpenses")}
                                                onBlur={this.calculate}
                                            />
                                        </FormGroup>
                                    </Colxx>
                                </Row>

                                <Row className="mt-3">
                                    <Colxx md="3">
                                        <FormGroup>
                                            <Label>دریافتی از راننده</Label>
                                            <Input
                                                value={toCurrency(ReceivedFromDriver)}
                                                onChange={this.handleChange("ReceivedFromDriver")}
                                                onBlur={this.calculate}
                                            />
                                        </FormGroup>
                                    </Colxx>

                                    <Colxx md="3">
                                        <FormGroup>
                                            <Label>باقی مانده کرایه</Label>
                                            <Input
                                                value={toCurrency(RemainingFreight)}
                                                onChange={this.handleChange("RemainingFreight")}
                                                onBlur={this.calculate}
                                            />
                                        </FormGroup>
                                    </Colxx>
                                </Row>
                                <Colxx md="3">
                                <Button
                                    color="primary"
                                    className="mt-4"
                                    onClick={this.handleManualCalculate}
                                >
                                    محاسبه هزینه‌ها و ضرایب مالی
                                </Button>
                                </Colxx>

                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>
                {/* بخش نهایی: بیمه، وضعیت و دکمه‌ها */}
                <Row className="mb-5">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody>
                                <CardTitle>سایر اطلاعات</CardTitle>
                                <Row>
                                    <Colxx md="4">
                                        <FormGroup>
                                            <Label>نماینده صاحب کالا</Label>
                                            <Autocomplete options={TransportationCompanyProductOwnerList} value={TransportationCompanyProductOwner}
                                                getOptionLabel={o => o.productOwnerName}
                                                onChange={(e, v) => this.selectHandleChange(e, v, "TransportationCompanyProductOwner")}
                                                renderInput={params => <TextField {...params} variant="outlined" size="small" />} />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx md="4">
                                        <FormGroup>
                                            <Label>بیمه مسئولیت</Label>
                                            <Autocomplete options={InsuranceContractList} value={InsuranceContract}
                                                getOptionLabel={o => o.insuranceCompanyName + " " + o.isActiveName + " " + o.insuranceContractNumber}
                                                onChange={(e, v) => this.selectHandleChange(e, v, "InsuranceContract")}
                                                renderInput={params => <TextField {...params} variant="outlined" size="small" />} />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx md="4">
                                        <FormGroup>
                                            <Label>وضعیت حمل</Label>
                                            <Autocomplete options={ShippingStatus} value={selectedShippingStatus}
                                                getOptionLabel={o => o.text}
                                                onChange={(e, v) => this.selectHandleChange(e, v, "selectedShippingStatus")}
                                                renderInput={params => <TextField {...params} variant="outlined" size="small" />} />
                                        </FormGroup>
                                    </Colxx>
                                </Row>

                                <Row className="mt-3">
                                    <Colxx md="4">
                                        <FormGroup>
                                            <Label>تاریخ تقریبی رسیدن</Label>
                                            <DatePicker value={EstimatedArrivalDate} onChange={d => this.setState({ EstimatedArrivalDate: d })}
                                                inputClassName="form-control" locale="fa" />
                                        </FormGroup>
                                    </Colxx>
                                    <Colxx md="8">
                                        <FormGroup>
                                            <Label>توضیحات</Label>
                                            <Input value={Desc} type="textarea" rows="2"
                                                onChange={e => this.setState({ Desc: e.target.value })} />
                                        </FormGroup>
                                    </Colxx>
                                </Row>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                {/* خطاها و دکمه‌های نهایی */}
                <Row>
                    <Colxx xxs="12" className="text-center">
                        {errors.length > 0 && (
                            <div className="mb-4">
                                {errors.map((err, i) => <Alert color="danger" key={i}>{err}</Alert>)}
                            </div>
                        )}

                        <Button size="lg" color="primary" className="mx-3"
                            onClick={() => this.props.showSweetAlert("", "آیا از ثبت بارنامه اطمینان دارید؟", "warning", this.validateInputData)}>
                            ثبت بارنامه
                        </Button>


                        <Button size="lg" outline color="secondary" className="mx-3"
                            onClick={() => this.props.showSweetAlert("", "همه اطلاعات پاک شود؟", "danger", this.reset)}>
                            پاک کردن فرم
                        </Button>
                    </Colxx>
                </Row>
                <Row className="mb-5">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody>

                                <Row>
                                    <Colxx xxs="12" className="text-center">


                                        <Button
                                            size="lg"
                                            color="info"
                                            className="mx-3"
                                            onClick={this.restSteelInformation}
                                        >
                                            مشاهده اطلاعات فولادی
                                        </Button>
                                        <Button
                                            size="lg"
                                            color="info"
                                            className="mx-3"
                                            onClick={this.restCustomsInformation}
                                        >
                                            مشاهده اطلاعات گمرکی
                                        </Button>
                                        <Button
                                            size="lg"
                                            color="info"
                                            className="mx-3"
                                            onClick={this.resetBillPayment}
                                        >
                                            مشاهده اطلاعات پرداختی
                                        </Button>
                                        <Button
                                            size="lg"
                                            color="info"
                                            className="mx-3"
                                            onClick={this.resetOil}
                                        >
                                            مشاهده اطلاعات نفتی
                                        </Button>
                                    </Colxx>
                                </Row>

                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>
                <Modal isOpen={this.state.CustomsInformationModal} toggle={() => this.closeModal("CustomsInformationModal")} size="xlg">
                    <ModalHeader toggle={() => this.closeModal("CustomsInformationModal")}>
                        اطلاعات گمرکی
                    </ModalHeader>
                    <ModalBody>
                        <Row className="mb-5">

                            <Colxx xxs="12">
                                <Card>
                                    <CardBody>

                                        <Row>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>شماره کانتینر 1</Label>
                                                    <Input value={ContainerNumber1}
                                                        onChange={e => this.setState({ ContainerNumber1: e.target.value })} />
                                                </FormGroup>
                                            </Colxx>
                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>شماره کانتینر 2</Label>
                                                    <Input value={ContainerNumber2}
                                                        onChange={e => this.setState({ ContainerNumber2: e.target.value })} />
                                                </FormGroup>
                                            </Colxx>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>شماره کوتاژ</Label>
                                                    <Input value={CotageNumber}
                                                        onChange={e => this.setState({ CotageNumber: e.target.value })} />
                                                </FormGroup>
                                            </Colxx>
                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>تاریخ کوتاژ</Label>
                                                    <DatePicker value={CotageDate} onChange={d => this.setState({ CotageDate: d })}
                                                        inputClassName="form-control" locale="fa" />
                                                </FormGroup>
                                            </Colxx>
                                        </Row>

                                        <Row>


                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>بارکد کالا</Label>
                                                    <Input value={ProductBarcode}
                                                        onChange={e => this.setState({ ProductBarcode: e.target.value })} />
                                                </FormGroup>
                                            </Colxx>
                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label> شماره پلمپ گمرکی </Label>
                                                    <Input value={CustomsSealNumber}
                                                        onChange={e => this.setState({ CustomsSealNumber: e.target.value })} />
                                                </FormGroup>
                                            </Colxx>
                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label> شماره پروانه گمرکی </Label>
                                                    <Input value={CustomsPermitNumber}
                                                        onChange={e => this.setState({ CustomsPermitNumber: e.target.value })} />
                                                </FormGroup>
                                            </Colxx>

                                        </Row>
                                        < Row>
                                            <div className="d-flex mb-2 mt-4 justify-content-center align-items-center">
                                                <Button color="primary" className="btn-lg mx-2" onClick={() => this.setState({ IsCustomsInformation: true, CustomsInformationModal: false })}>
                                                    ثبت
                                                </Button>
                                            </div>

                                        </Row>
                                    </CardBody>
                                </Card>
                            </Colxx>





                        </Row>
                    </ModalBody>
                </Modal>
                <Modal
                    isOpen={this.state.SteelInformationModal}
                    size="xlg"
                    toggle={() => this.closeModal("SteelInformationModal")} // فقط این
                >
                    <ModalHeader toggle={() => this.closeModal("SteelInformationModal")}>
                        اطلاعات فولادی
                    </ModalHeader>

                    <ModalBody>
                        {this.state.steelErrors.length > 0 && (
                            <div className="alert alert-danger">
                                <ul className="mb-0">
                                    {this.state.steelErrors.map((err, i) => (
                                        <li key={i}>{err}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        <Row>
                            <Colxx md="3">
                                <FormGroup>
                                    <Label>شماره سفارش</Label>
                                    <Input
                                        value={this.state.SteelOrderNumber}
                                        onChange={e => this.setState({ SteelOrderNumber: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>

                            <Colxx md="3">
                                <FormGroup>
                                    <Label>موقعیت / شماره حواله</Label>
                                    <Input
                                        value={this.state.SteelDraftPosition}
                                        onChange={e => this.setState({ SteelDraftPosition: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>

                            <Colxx md="3">
                                <FormGroup>
                                    <Label>وزن برنامه‌ریزی شده</Label>
                                    <Input
                                        value={this.state.SteelPlannedWeight}
                                        onChange={e => this.setState({ SteelPlannedWeight: e.target.value.replace(/[^0-9.]/g, "") })}
                                    />
                                </FormGroup>
                            </Colxx>

                            <Colxx md="3">
                                <FormGroup>
                                    <Label>تعداد</Label>
                                    <Input
                                        value={this.state.SteelQuantity}
                                        onChange={e => this.setState({ SteelQuantity: e.target.value.replace(/[^0-9]/g, "") })}
                                    />
                                </FormGroup>
                            </Colxx>
                        </Row>

                        <Row>
                            <Colxx md="3">
                                <FormGroup>
                                    <Label>نام مشتری</Label>
                                    <Input
                                        value={this.state.SteelCustomerName}
                                        onChange={e => this.setState({ SteelCustomerName: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>

                            <Colxx md="3">
                                <FormGroup>
                                    <Label>کد مشتری</Label>
                                    <Input
                                        value={this.state.SteelCustomerCode}
                                        onChange={e => this.setState({ SteelCustomerCode: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>

                            <Colxx md="3">
                                <FormGroup>
                                    <Label>نوع محصول</Label>
                                    <Input
                                        value={this.state.SteelProductType}
                                        onChange={e => this.setState({ SteelProductType: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>
                            <Colxx md="3">
                                <FormGroup>
                                    <Label>مکانیزم</Label>
                                    <Input
                                        value={this.state.Mechanism}
                                        onChange={e => this.setState({ Mechanism: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>


                        </Row>

                        <Row>
                            <Colxx md="3">
                                <FormGroup>
                                    <Label>ضخامت (میلی‌متر)</Label>
                                    <Input
                                        value={this.state.SteelThickness}
                                        onChange={e => this.setState({ SteelThickness: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>
                            <Colxx md="3">
                                <FormGroup>
                                    <Label>عرض (میلی‌متر)</Label>
                                    <Input
                                        value={this.state.SteelWidth}
                                        onChange={e => this.setState({ SteelWidth: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>

                            <Colxx md="3">
                                <FormGroup>
                                    <Label>طول (میلی‌متر)</Label>
                                    <Input
                                        value={this.state.SteelLength}
                                        onChange={e => this.setState({ SteelLength: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>

                            <Colxx md="3">
                                <FormGroup>
                                    <Label>طول مفید</Label>
                                    <Input
                                        value={this.state.SteelUsefulLength}
                                        onChange={e => this.setState({ SteelUsefulLength: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>
                        </Row>
                        <Row>
                            <Colxx md="3">
                                <FormGroup>
                                    <Label>انبار / منطقه بارگیری</Label>
                                    <Input
                                        value={this.state.SteelWarehouse}
                                        onChange={e => this.setState({ SteelWarehouse: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>
                            <Colxx md="3">
                                <FormGroup>
                                    <Label>ISG</Label>
                                    <Input
                                        value={this.state.SteelISG}
                                        onChange={e => this.setState({ SteelISG: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>

                            <Colxx md="3">
                                <FormGroup>
                                    <Label>آیتم</Label>
                                    <Input
                                        value={this.state.SteelItem}
                                        onChange={e => this.setState({ SteelItem: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>



                            <Colxx md="3">
                                <FormGroup>
                                    <Label>کد نقطه بارگیری</Label>
                                    <Input
                                        value={this.state.SteelLoadingPoint}
                                        onChange={e => this.setState({ SteelLoadingPoint: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>
                        </Row>

                        <Row>
                            <Colxx md="12">
                                <FormGroup>
                                    <Label>برنامه فولاد</Label>
                                    <Input
                                        value={this.state.SteelProgram}
                                        onChange={e => this.setState({ SteelProgram: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>

                            <Colxx md="12">
                                <FormGroup>
                                    <Label>توضیحات</Label>
                                    <Input
                                        type="textarea"
                                        rows="2"
                                        value={this.state.SteelDescription}
                                        onChange={e => this.setState({ SteelDescription: e.target.value })}
                                    />
                                </FormGroup>
                            </Colxx>
                        </Row>
                    </ModalBody>

                    <ModalFooter>
                        <Button
                            color="primary"
                            /*onClick={() => this.setState({ IsSteelInformation: true, SteelInformationModal: false })}*/
                            onClick={this.SaveSteelInformation}
                        >
                            ثبت
                        </Button>


                    </ModalFooter>
                </Modal>
                <Modal
                    isOpen={this.state.BillPaymentModal}
                    toggle={() => this.closeModal("BillPaymentModal")}
                    size="xlg"
                >
                    <ModalHeader toggle={() => this.closeModal("BillPaymentModal")}>
                        اطلاعات پرداختی
                    </ModalHeader>

                    <ModalBody>
                        <Row className="mb-5">
                            <Colxx xxs="12">
                                <Card>
                                    <CardBody>

                                        {/* پرداخت‌کننده */}
                                        <Row>
                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>تلفن پرداخت‌کننده</Label>
                                                    <Input
                                                        value={PayerPhone}
                                                        onChange={e => this.setState({ PayerPhone: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Colxx>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>تاریخ تولد پرداخت‌کننده</Label>
                                                    <DatePicker
                                                        value={PayerBirthDate}
                                                        onChange={d => this.setState({ PayerBirthDate: d })}
                                                        inputClassName="form-control"
                                                        locale="fa"
                                                    />
                                                </FormGroup>
                                            </Colxx>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>کد ملی پرداخت‌کننده</Label>
                                                    <Input
                                                        value={PayerNationalId}
                                                        onChange={e => this.setState({ PayerNationalId: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Colxx>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>شناسه ملی شرکت پرداخت‌کننده</Label>
                                                    <Input
                                                        value={PayerCompanyNationalId}
                                                        onChange={e => this.setState({ PayerCompanyNationalId: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Colxx>
                                        </Row>

                                        {/* مدیرعامل پرداخت‌کننده */}
                                        <Row>
                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>کد ملی مدیرعامل</Label>
                                                    <Input
                                                        value={PayerManagerNationalId}
                                                        onChange={e => this.setState({ PayerManagerNationalId: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Colxx>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>تلفن مدیرعامل</Label>
                                                    <Input
                                                        value={PayerManagerPhone}
                                                        onChange={e => this.setState({ PayerManagerPhone: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Colxx>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>تاریخ تولد مدیرعامل</Label>
                                                    <DatePicker
                                                        value={PayerManagerBirthDate}
                                                        onChange={d => this.setState({ PayerManagerBirthDate: d })}
                                                        inputClassName="form-control"
                                                        locale="fa"
                                                    />
                                                </FormGroup>
                                            </Colxx>
                                        </Row>

                                        {/* دریافت‌کننده */}
                                        <Row>
                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>کد ملی دریافت‌کننده</Label>
                                                    <Input
                                                        value={ReceiverNationalId}
                                                        onChange={e => this.setState({ ReceiverNationalId: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Colxx>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>تلفن دریافت‌کننده</Label>
                                                    <Input
                                                        value={ReceiverPhone}
                                                        onChange={e => this.setState({ ReceiverPhone: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Colxx>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>تاریخ تولد دریافت‌کننده</Label>
                                                    <DatePicker
                                                        value={ReceiverBirthDate}
                                                        onChange={d => this.setState({ ReceiverBirthDate: d })}
                                                        inputClassName="form-control"
                                                        locale="fa"
                                                    />
                                                </FormGroup>
                                            </Colxx>
                                        </Row>

                                        {/* دکمه ثبت */}
                                        <Row>
                                            <div className="d-flex mb-2 mt-4 justify-content-center align-items-center">
                                                <Button
                                                    color="primary"
                                                    className="btn-lg mx-2"
                                                    onClick={() =>
                                                        this.setState({
                                                            IsBillPayment: true,
                                                            BillPaymentModal: false
                                                        })
                                                    }
                                                >
                                                    ثبت
                                                </Button>
                                            </div>
                                        </Row>

                                    </CardBody>
                                </Card>
                            </Colxx>
                        </Row>
                    </ModalBody>
                </Modal>
                <Modal
                    isOpen={this.state.OilModal}
                    toggle={() => this.closeModal("OilModal")}
                    size="xlg"
                >
                    <ModalHeader toggle={() => this.closeModal("OilModal")}>
                        اطلاعات نفتی
                    </ModalHeader>

                    <ModalBody>
                        {this.state.oilErrors.length > 0 && (
                            <div className="alert alert-danger">
                                <ul className="mb-0">
                                    {this.state.oilErrors.map((err, i) => (
                                        <li key={i}>{err}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        <Row className="mb-5">
                            <Colxx xxs="12">
                                <Card>
                                    <CardBody>

                                        <Row>
                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>شماره بارنامه یا حواله</Label>
                                                    <Input
                                                        type="number"
                                                        value={DraftOrBillNumber}
                                                        onChange={e => this.setState({ DraftOrBillNumber: toEnglishNumbers(e.target.value.replace(/[^0-9]/g, "")) })}
                                                    />
                                                </FormGroup>
                                            </Colxx>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>تاریخ صدور</Label>
                                                    <DatePicker
                                                        value={IssueDate}
                                                        onChange={d => this.setState({ IssueDate: d })}
                                                        inputClassName="form-control"
                                                        locale="fa"
                                                    />
                                                </FormGroup>
                                            </Colxx>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>درجه حرارت</Label>
                                                    <Input
                                                        type="number"
                                                        value={Temperature}
                                                        onChange={e => this.setState({ Temperature: toEnglishNumbers(e.target.value.replace(/[^0-9]/g, "")) })}
                                                    />
                                                </FormGroup>
                                            </Colxx>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>وزن مخصوص</Label>
                                                    <Input
                                                        type="number"
                                                        step="0.01"
                                                        value={SpecificGravity}
                                                        onChange={e => this.setState({ SpecificGravity: toEnglishNumbers(e.target.value.replace(/[^0-9]/g, "")) })}
                                                    />
                                                </FormGroup>
                                            </Colxx>
                                        </Row>

                                        <Row>
                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>مقدار طبیعی (لیتر)</Label>
                                                    <Input
                                                        type="number"
                                                        value={NaturalQuantity}
                                                        onChange={e => this.setState({ NaturalQuantity: toEnglishNumbers(e.target.value.replace(/[^0-9]/g, "")) })}
                                                    />
                                                </FormGroup>
                                            </Colxx>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>مقدار در دمای 60 درجه</Label>
                                                    <Input
                                                        type="number"
                                                        value={Quantityat60Degrees}
                                                        onChange={e => this.setState({ Quantityat60Degrees: toEnglishNumbers(e.target.value.replace(/[^0-9]/g, "")) })}
                                                    />
                                                </FormGroup>
                                            </Colxx>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>وزن محموله</Label>
                                                    <Input
                                                        type="number"
                                                        value={KalaWeight}
                                                        onChange={e => this.setState({ KalaWeight: toEnglishNumbers(e.target.value.replace(/[^0-9]/g, "")) })}
                                                    />
                                                </FormGroup>
                                            </Colxx>

                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>شماره راهداردی</Label>
                                                    <Input
                                                        type="number"
                                                        value={RahdardiNumber}
                                                        onChange={e => this.setState({ RahdardiNumber: toEnglishNumbers(e.target.value.replace(/[^0-9]/g, "")) })}
                                                    />
                                                </FormGroup>
                                            </Colxx>
                                        </Row>

                                        <Row>
                                            <Colxx md="3" sm="6">
                                                <FormGroup>
                                                    <Label>شناسه قرارداد بیمه</Label>
                                                    <Autocomplete options={InsuranceContractList} value={OilInsuranceContract}
                                                        getOptionLabel={o => o.insuranceCompanyName + " " + o.isActiveName + " " + o.insuranceContractNumber}
                                                        onChange={(e, v) => this.selectHandleChange(e, v, "OilInsuranceContract")}
                                                        renderInput={params => <TextField {...params} variant="outlined" size="small" />} />
                                                </FormGroup>
                                            </Colxx>
                                        </Row>

                                      

                                    </CardBody>
                                </Card>
                            </Colxx>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            
                            onClick={this.SaveOil}
                        >
                            ثبت
                        </Button>

                        
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.addCustomerModal} size="xlg" toggle={() => this.closeModal("addCustomerModal")}>
                    <ModalHeader toggle={() => this.closeModal("addCustomerModal")}>
                        افزودن مشتری جدید
                    </ModalHeader>
                    <ModalBody>
                        <AddCustomerModal
                            provinces={this.state.provinces}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("addCustomerModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.editCustomerModal} size="xlg" toggle={() => this.closeModal("editCustomerModal")}>
                    <ModalHeader toggle={() => this.closeModal("editCustomerModal")}>
                        ویرایش مشتری
                    </ModalHeader>
                    <ModalBody>
                        <EditCustomer
                            selectedCustomerToEdit={this.state.currentCustomer}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("editCustomerModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.manageCustomersModal} size="xlg" toggle={() => this.closeModal("manageCustomersModal")}>
                    <ModalHeader toggle={() => this.closeModal("manageCustomersModal")}>
                        مدیریت مشتریان
                    </ModalHeader>
                    <ModalBody>
                        <Customer
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("manageCustomersModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.manageCustomerModal} size="xlg" toggle={() => this.closeModal("manageCustomerModal")}>
                    <ModalHeader toggle={() => this.closeModal("manageCustomerModal")}>
                        مدیریت آدرس‌های
                        {' '}
                        {this.state.currentCustomer.name}
                    </ModalHeader>
                    <ModalBody>
                        <ManageCustomerAddress
                            provinces={this.state.provinces}
                            currentCustomer={this.state.currentCustomer}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("manageCustomerModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

            </>
        );
    }
}

export default AddBill;